var _style, _g, _g2, _rect, _path, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g5, _path15, _path16, _g6, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g7, _path30, _path31, _g8, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g9, _path45, _path46, _g10, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g11, _path60, _path61, _g12, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g13, _path75, _path76, _g14, _path77, _g15, _g16, _g17, _g18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1330 960",
    style: {
      enableBackground: "new 0 0 1330 960"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#51AFE2;}\r\n\t.st1{opacity:0.2;fill:#70CDDD;stroke:#FFF68D;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#CFEDFC;}\r\n\t.st4{fill:#55BBEA;}\r\n\t.st5{fill:#F36C3E;}\r\n\t.st6{fill:#F48054;}\r\n\t.st7{fill:url(#XMLID_56_);}\r\n\t.st8{fill:url(#XMLID_57_);}\r\n\t.st9{fill:url(#XMLID_58_);}\r\n\t.st10{opacity:0.19;}\r\n\t.st11{fill:none;}\r\n\t.st12{opacity:0.19;fill:none;}\r\n\t.st13{fill:url(#XMLID_63_);}\r\n\t.st14{fill:url(#XMLID_64_);}\r\n\t.st15{fill:url(#XMLID_65_);}\r\n\t.st16{fill:#D85CA2;}\r\n\t.st17{fill:#E06BA9;}\r\n\t.st18{fill:url(#XMLID_66_);}\r\n\t.st19{fill:url(#XMLID_67_);}\r\n\t.st20{fill:url(#XMLID_68_);}\r\n\t.st21{fill:url(#XMLID_69_);}\r\n\t.st22{fill:url(#SVGID_1_);}\r\n\t.st23{fill:url(#XMLID_70_);}\r\n\t.st24{opacity:0.48;}\r\n\t.st25{fill:url(#XMLID_71_);}\r\n\t.st26{fill:url(#XMLID_72_);}\r\n\t.st27{fill:url(#XMLID_73_);}\r\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#FECE99;}\r\n\t.st29{fill:none;stroke:#DC4292;stroke-width:4.6674;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st30{opacity:0.19;fill:none;stroke:#DC4292;stroke-width:14.0023;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3629_",
    x: 0,
    y: 0,
    className: "st0",
    width: 1330,
    height: 960
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3623_",
    className: "st1",
    d: "M1327.5,750.29c-167-23.69-329.59-75.57-479.3-152.77c-54.8-28.26-108.15-59.98-165.89-81.59 c-108.57-40.63-232.8-42.82-339.45,2.62C262,553.01,184.49,614.91,97.43,602.81c-34.04-4.73-64.92-20.7-95.92-36.42v-184.1 c167-23.69,329.5-75.57,479.21-152.77c54.8-28.26,108.1-59.98,165.84-81.59c108.57-40.63,232.78-42.82,339.43,2.62 c80.86,34.46,158.46,96.35,245.52,84.26c34.04-4.73,65.01-20.7,96.01-36.42V750.29z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3670_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3675_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M848.38,472.49c-0.04,16.08-3.15,32.16-9.22,47.06c-6.06,14.9-15.11,28.55-26.37,39.98 c-11.26,11.45-24.84,20.57-39.63,26.7c-14.79,6.15-30.8,9.23-46.76,9.1c-15.96-0.13-31.86-3.48-46.45-9.84 c-14.6-6.32-27.84-15.63-38.83-27.05c-11.02-11.4-19.74-24.96-25.64-39.65c-5.92-14.68-8.92-30.5-8.91-46.31 c-0.02-15.81,2.98-31.63,8.91-46.31c5.89-14.68,14.61-28.25,25.63-39.65c10.99-11.42,24.23-20.73,38.83-27.05 c14.58-6.35,30.49-9.7,46.45-9.84c15.96-0.13,31.97,2.95,46.76,9.1c14.79,6.13,28.37,15.25,39.63,26.7 c11.26,11.44,20.31,25.09,26.37,39.98C845.23,440.32,848.34,456.41,848.38,472.49z M843.29,472.49 c0.02-15.44-2.91-30.89-8.69-45.21c-5.75-14.33-14.26-27.57-25.02-38.7c-10.73-11.14-23.64-20.23-37.88-26.4 c-14.22-6.2-29.73-9.47-45.3-9.61c-15.57-0.13-31.19,2.87-45.61,8.87c-14.43,5.98-27.68,14.88-38.68,26.05 c-11,11.16-19.83,24.49-25.75,39.04c-5.93,14.54-8.96,30.24-9,45.96c0.04,15.71,3.07,31.42,9,45.96 c5.92,14.55,14.75,27.87,25.75,39.04c11,11.17,24.25,20.07,38.68,26.05c14.43,6,30.04,9,45.61,8.87 c15.57-0.14,31.08-3.41,45.3-9.61c14.24-6.17,27.15-15.26,37.88-26.4c10.76-11.12,19.27-24.37,25.02-38.7 C840.38,503.37,843.3,487.93,843.29,472.49z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3674_",
    className: "st3",
    d: "M627.76,465.11c0,0-0.02-0.48-0.05-1.39c-0.02-0.45-0.04-1.01-0.06-1.67 c-0.04-0.65-0.04-1.41-0.02-2.29c0.01-0.87,0.03-1.84,0.04-2.89c0.07-1.04,0.14-2.17,0.22-3.37c0.2-2.41,0.52-5.12,1.05-8.07 c0.25-1.48,0.62-2.99,0.95-4.58c0.42-1.56,0.81-3.19,1.34-4.84c1-3.31,2.31-6.72,3.86-10.19c1.61-3.43,3.45-6.93,5.63-10.3 c2.19-3.37,4.62-6.68,7.33-9.78c2.72-3.09,5.66-6.01,8.75-8.69c3.13-2.63,6.38-5.05,9.7-7.16c3.35-2.05,6.68-3.94,10.01-5.4 c1.63-0.81,3.3-1.39,4.88-2.06c1.61-0.59,3.18-1.15,4.7-1.63c1.53-0.44,2.99-0.92,4.41-1.26c1.42-0.33,2.76-0.69,4.04-0.94 c1.28-0.24,2.49-0.46,3.6-0.67c1.12-0.15,2.15-0.29,3.08-0.42c1.86-0.28,3.34-0.32,4.34-0.43c1.01-0.08,1.54-0.12,1.54-0.12 c4.97-0.39,9.32,3.31,9.71,8.28c0.39,4.97-3.31,9.32-8.28,9.71c-0.35,0.03-0.7,0.04-1.04,0.02l-0.39-0.02c0,0-0.43-0.02-1.23-0.05 c-0.8-0.01-1.98-0.14-3.48-0.09c-0.75,0.01-1.59,0.01-2.49,0.02c-0.91,0.05-1.89,0.11-2.93,0.17c-1.05,0.07-2.16,0.23-3.33,0.34 c-1.18,0.13-2.4,0.38-3.69,0.57c-1.28,0.24-2.6,0.54-3.98,0.85c-1.35,0.39-2.79,0.69-4.21,1.19c-2.89,0.85-5.84,2.08-8.86,3.44 c-3,1.42-6,3.12-8.96,5.03c-2.92,1.96-5.77,4.16-8.48,6.55c-2.69,2.41-5.19,5.05-7.51,7.8c-2.31,2.76-4.34,5.68-6.18,8.59 c-1.78,2.95-3.37,5.91-4.66,8.83c-0.67,1.45-1.21,2.91-1.78,4.3c-0.48,1.42-1.01,2.79-1.41,4.13c-0.83,2.68-1.45,5.19-1.92,7.43 c-0.21,1.13-0.41,2.19-0.6,3.16c-0.14,0.98-0.26,1.87-0.37,2.68c-0.13,0.8-0.21,1.55-0.25,2.21c-0.06,0.65-0.11,1.21-0.14,1.66 c-0.08,0.9-0.12,1.38-0.12,1.38c-0.07,0.75-0.73,1.31-1.48,1.24C628.31,466.37,627.78,465.79,627.76,465.11z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3673_",
    className: "st3",
    cx: 628.73,
    cy: 477.4,
    rx: 4.9,
    ry: 4.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3672_",
    className: "st4",
    d: "M699.05,515.15c-14.93,14.53-38.2,27.19-59.73,25.66c19.87,26.18,50,42.88,83.74,42.88 c59.89,0,108.38-52.59,108.38-117.41c0-0.46-0.01-0.91-0.02-1.36C782.7,453.44,737.54,479.85,699.05,515.15z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3671_",
    className: "st3",
    cx: 821.4,
    cy: 443.52,
    r: 7.94
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3630_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    className: "st2",
    d: "M658.12,178.44c0,0-0.05,0.92-0.14,2.65c-0.03,0.43-0.03,0.91-0.1,1.45 c-0.08,0.55-0.17,1.15-0.27,1.79c-0.1,0.64-0.19,1.35-0.33,2.07c-0.18,0.72-0.38,1.48-0.58,2.28c-0.1,0.4-0.21,0.81-0.32,1.24 c-0.15,0.41-0.3,0.83-0.45,1.26c-0.33,0.86-0.61,1.78-1.01,2.69c-0.43,0.9-0.88,1.84-1.35,2.81c-0.51,0.95-1.13,1.88-1.71,2.88 c-2.52,3.85-6.06,7.8-10.76,10.97c-4.71,3.13-10.57,5.43-16.99,6.14c-0.8,0.12-1.62,0.09-2.43,0.14l-1.23,0.05l-0.62,0.02 c-0.27,0-0.42-0.02-0.64-0.03c-1.62-0.12-3.26-0.13-4.95-0.48c-3.38-0.46-6.66-1.58-9.85-3.02c-0.78-0.39-1.56-0.79-2.35-1.19 c-0.77-0.43-1.5-0.93-2.25-1.4c-0.37-0.24-0.75-0.47-1.12-0.72l-1.05-0.82c-0.69-0.56-1.44-1.06-2.09-1.68 c-2.71-2.36-5.05-5.17-7.07-8.21c-1.97-3.08-3.45-6.48-4.55-10c-1.04-3.55-1.48-7.25-1.56-10.95c0.08-3.69,0.53-7.4,1.56-10.95 c1.1-3.52,2.58-6.92,4.55-10c2.02-3.04,4.36-5.85,7.07-8.21c0.65-0.62,1.4-1.12,2.09-1.68l1.05-0.82 c0.37-0.25,0.75-0.48,1.12-0.72c0.75-0.46,1.48-0.97,2.25-1.4c0.79-0.4,1.57-0.79,2.35-1.19c3.18-1.43,6.48-2.56,9.83-3.01 c1.66-0.35,3.34-0.37,4.99-0.49c0.22-0.01,0.38-0.03,0.65-0.03l0.61,0.02l1.21,0.05c0.81,0.05,1.59,0.02,2.4,0.14 c6.49,0.72,12.29,3.01,17.02,6.14c4.71,3.17,8.25,7.12,10.76,10.97c0.59,0.99,1.2,1.93,1.71,2.88c0.47,0.97,0.92,1.91,1.35,2.81 c0.41,0.91,0.69,1.83,1.01,2.69c0.15,0.43,0.31,0.85,0.45,1.26c0.11,0.42,0.21,0.84,0.32,1.24c0.21,0.8,0.4,1.56,0.58,2.28 c0.15,0.72,0.23,1.41,0.33,2.05c0.1,0.64,0.19,1.23,0.27,1.77c0.07,0.54,0.07,1.04,0.1,1.48c0.09,1.77,0.14,2.72,0.14,2.72 L658.12,178.44z M655.94,178.38c0,0-0.04-0.9-0.12-2.57c-0.03-0.42-0.02-0.89-0.09-1.4c-0.08-0.51-0.16-1.07-0.25-1.67 c-0.1-0.6-0.17-1.25-0.3-1.94c-0.17-0.68-0.35-1.4-0.54-2.16c-0.82-3.01-2.13-6.65-4.5-10.33c-2.33-3.69-5.66-7.47-10.06-10.61 c-4.41-3.08-10-5.42-16.11-6.25c-0.76-0.14-1.58-0.12-2.37-0.2l-1.21-0.08l-0.61-0.04l-0.57,0.02c-1.59,0.08-3.22,0.05-4.84,0.36 c-3.26,0.37-6.49,1.39-9.63,2.71c-0.77,0.37-1.55,0.73-2.32,1.1c-0.76,0.4-1.49,0.88-2.24,1.32c-0.37,0.23-0.75,0.44-1.12,0.68 l-1.05,0.78c-0.69,0.54-1.44,1.01-2.09,1.6c-2.71,2.27-5.05,5.01-7.08,7.98c-2,3.01-3.49,6.36-4.59,9.84 c-1.04,3.51-1.5,7.16-1.6,10.84c0.1,3.67,0.56,7.33,1.6,10.84c1.1,3.48,2.59,6.84,4.59,9.84c2.04,2.97,4.37,5.72,7.08,7.98 c0.65,0.59,1.4,1.07,2.09,1.6l1.05,0.78c0.37,0.24,0.75,0.45,1.12,0.68c0.75,0.44,1.47,0.92,2.24,1.32 c0.78,0.37,1.55,0.74,2.32,1.1c3.13,1.32,6.39,2.34,9.62,2.71c1.58,0.31,3.26,0.28,4.88,0.36c0.75,0.06,1.58-0.07,2.36-0.1 c0.79-0.07,1.57-0.05,2.34-0.19c6.17-0.83,11.72-3.17,16.15-6.25c4.4-3.14,7.73-6.92,10.06-10.61c2.37-3.69,3.68-7.32,4.5-10.33 c0.19-0.76,0.37-1.48,0.54-2.16c0.13-0.68,0.2-1.32,0.3-1.91c0.09-0.59,0.17-1.14,0.25-1.65c0.07-0.51,0.06-1.01,0.09-1.43 c0.08-1.73,0.13-2.65,0.13-2.65L655.94,178.38z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3655_",
    className: "st3",
    d: "M588.99,176.08c0,0-0.01-0.15-0.02-0.43c-0.01-0.14-0.01-0.32-0.02-0.52 c-0.01-0.2-0.01-0.44-0.01-0.71c0-0.27,0.01-0.57,0.01-0.9c0.02-0.33,0.04-0.68,0.07-1.05c0.06-0.75,0.16-1.6,0.33-2.52 c0.08-0.46,0.19-0.93,0.3-1.43c0.13-0.49,0.25-1,0.42-1.51c0.31-1.03,0.72-2.1,1.2-3.18c0.5-1.07,1.08-2.16,1.76-3.21 c0.68-1.05,1.44-2.08,2.29-3.05c0.85-0.96,1.76-1.88,2.73-2.71c0.98-0.82,1.99-1.57,3.03-2.23c1.04-0.64,2.08-1.23,3.12-1.69 c0.51-0.25,1.03-0.43,1.52-0.64c0.5-0.18,0.99-0.36,1.47-0.51c0.48-0.14,0.93-0.29,1.38-0.39c0.44-0.1,0.86-0.22,1.26-0.29 c0.4-0.07,0.78-0.14,1.12-0.21c0.35-0.05,0.67-0.09,0.96-0.13c0.58-0.09,1.04-0.1,1.36-0.13c0.31-0.02,0.48-0.04,0.48-0.04 c1.55-0.12,2.91,1.03,3.03,2.58c0.12,1.55-1.03,2.91-2.58,3.03c-0.11,0.01-0.22,0.01-0.33,0.01l-0.12-0.01 c0,0-0.13-0.01-0.38-0.02c-0.25,0-0.62-0.04-1.09-0.03c-0.23,0-0.49,0-0.78,0.01c-0.28,0.02-0.59,0.03-0.92,0.05 c-0.33,0.02-0.67,0.07-1.04,0.11c-0.37,0.04-0.75,0.12-1.15,0.18c-0.4,0.08-0.81,0.17-1.24,0.26c-0.42,0.12-0.87,0.21-1.31,0.37 c-0.9,0.27-1.82,0.65-2.77,1.07c-0.93,0.44-1.87,0.97-2.79,1.57c-0.91,0.61-1.8,1.3-2.65,2.04c-0.84,0.75-1.62,1.58-2.34,2.43 c-0.72,0.86-1.35,1.77-1.93,2.68c-0.56,0.92-1.05,1.85-1.45,2.76c-0.21,0.45-0.38,0.91-0.56,1.34c-0.15,0.44-0.32,0.87-0.44,1.29 c-0.26,0.84-0.45,1.62-0.6,2.32c-0.07,0.35-0.13,0.68-0.19,0.99c-0.04,0.3-0.08,0.58-0.12,0.84c-0.04,0.25-0.07,0.48-0.08,0.69 c-0.02,0.2-0.03,0.38-0.05,0.52c-0.02,0.28-0.04,0.43-0.04,0.43c-0.02,0.23-0.23,0.41-0.46,0.39 C589.16,176.47,589,176.29,588.99,176.08z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3633_",
    className: "st3",
    cx: 589.29,
    cy: 179.91,
    rx: 1.53,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3632_",
    className: "st4",
    d: "M611.23,191.69c-4.66,4.53-11.92,8.48-18.64,8.01c6.2,8.17,15.6,13.38,26.13,13.38 c18.69,0,33.82-16.41,33.82-36.63c0-0.14,0-0.28,0-0.43C637.34,172.44,623.24,180.68,611.23,191.69z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3631_",
    className: "st3",
    cx: 649.41,
    cy: 169.34,
    r: 2.48
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3615_",
    className: "st1",
    d: "M-0.5,672.76c194-166.03,462.12-218.99,714.99-186.07 c103.21,13.44,204.33,40.46,307.96,50.22c103.62,9.76,218.05-5.68,307.05-59.23v385.93c-33,15.5-69.61,25.67-106.46,30 C1079,910.57,941.38,839.46,810.17,777.67c-91.51-43.1-185.14-82.77-283.32-107.09c-98.18-24.32-201.68-32.91-300.96-13.56 c-78.53,15.3-156.39,50.63-226.39,90.6V672.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3507_"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3544_",
    className: "st5",
    d: "M726.24,708.18c0,0-83.74-42.13-103.1-22.78c-12.79,12.77-13.17,29.38-13.17,29.38 l96.64,17.96L726.24,708.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3543_",
    className: "st6",
    d: "M719.56,710.96c0,0-74.15-37.31-91.3-20.18c-11.33,11.32-11.66,26.03-11.66,26.03 l85.56,15.89L719.56,710.96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3542_",
    className: "st5",
    d: "M726.85,808.56c0,0-49.4,23.78-60.53,12.26c-7.35-7.61-7.42-17.32-7.42-17.32l56.71-9.51 L726.85,808.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3541_",
    className: "st6",
    d: "M722.98,806.86c0,0-43.74,21.06-53.6,10.86c-6.51-6.74-6.56-15.35-6.56-15.35l50.21-8.42 L722.98,806.86z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3540_",
    className: "st5",
    d: "M632.6,834.84c4.78-0.44,15.15-1.72,11.19-5.82c-11.91-12.3-10.4-26.93,8.11-48.07 c-15.9-14.5-34.51-20.68-46.68-16.04c-6.91,15.89-7.17,32.73-4.86,40.25C604.68,819.15,615.15,836.46,632.6,834.84z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3539_",
    className: "st6",
    d: "M630.75,832.14c4.02-0.37,12.74-1.44,9.41-4.89c-10.02-10.35-8.76-22.64,6.81-40.43 c-13.38-12.2-29.02-17.4-39.26-13.49c-5.8,13.36-6.03,27.53-4.08,33.85C607.26,818.94,616.07,833.5,630.75,832.14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3538_",
    className: "st5",
    d: "M727.51,794.01c13.5-13.5,13.68-35.52,0.41-49.24l22.97-11.34 c19.5,20.15,19.22,52.5-0.62,72.31L727.51,794.01z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3537_",
    className: "st6",
    d: "M731.36,790.33c11.48-11.46,11.63-30.17,0.35-41.82l19.5-9.63 c16.56,17.12,16.33,44.6-0.51,61.42L731.36,790.33z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3536_",
    className: "st5",
    d: "M546.74,759.13c0,0,37.22,52.76,95.93,53.27c58.71,0.52,99.22-7.75,99.52-42.89 c2.48-10.88-10.35-45.29-101.46-63.26C582.02,705.74,546.74,759.13,546.74,759.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: -1889.2866,
    y1: 798.7014,
    x2: -1889.2866,
    y2: 692.5742,
    gradientTransform: "matrix(-1 -8.600000e-03 -8.600000e-03 1 -1238.3728 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD58C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3325"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3535_",
    className: "st7",
    d: "M546.61,759.25c0,0,37.24,52.76,95.95,53.27c58.72,0.52,99.22-7.75,99.5-42.89 c2.48-10.88-10.33-45.3-101.43-63.26C581.9,705.86,546.61,759.25,546.61,759.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3532_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: -1920.9912,
    y1: 748.5835,
    x2: -1920.9912,
    y2: 709.5762,
    gradientTransform: "matrix(-1 -8.600000e-03 -8.600000e-03 1 -1238.3728 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD58C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3325"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3534_",
    className: "st8",
    d: "M624.85,735.88c1.61,0.99,3.26,1.68,4.87,2.06c3.77,0.84,10.12,4.12,9.22,8.86 c2.35-0.79,4.31-6.52,3.2-14.12c2.95,1.76,6.03,3.06,8.8,5.03c11.26,8.01,11.48,10.98,12.41,19.15c0.22,1.95,3.2,2.48,4.35,1.21 c5.66-6.32,6.85-14.25,2.89-23.45c-1.88-4.36-4.31-8.03-7.01-11.06c1.14,0.03,2.3,0.07,3.44,0.09c0.05,0.03,0.09,0.07,0.14,0.09 c2.01,1.25,4.11,2.09,6,3.44c7.08,5.03,7.21,6.9,7.79,12.02c0.14,1.23,2.04,1.57,2.73,0.77c3.56-3.98,4.32-8.97,1.83-14.73 c-0.15-0.35-0.32-0.68-0.49-1.01c4.9,1.81,9.4,3.66,13.53,5.55c0.05,0.31,0.03,0.56-0.09,0.73c0.31-0.05,0.63-0.19,0.92-0.36 c1.09,0.51,2.15,1.01,3.19,1.52c0.18,0.21,0.38,0.44,0.59,0.61c1.13,0.95,2.7,3.16,1.6,4.6c0.72,0.11,1.9-0.87,2.81-2.63 c18.62,10.07,27.61,20.66,31.36,28.94l-125.48-1.11C617.85,762.15,624.91,751.5,624.85,735.88z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -1879.9371,
    y1: 743.5817,
    x2: -1879.9371,
    y2: 693.1577,
    gradientTransform: "matrix(-1 -8.600000e-03 -8.600000e-03 1 -1238.3728 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD58C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3325"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3531_",
    className: "st9",
    d: "M686.69,720.3c2.49,5.76,1.75,10.76-1.81,14.72c-0.71,0.8-2.6,0.47-2.73-0.76 c-0.59-5.14-0.72-6.99-7.8-12.04c-1.89-1.35-3.99-2.19-6-3.43c-0.04-0.04-0.09-0.07-0.14-0.11c-1.14-0.03-2.3-0.05-3.44-0.08 c2.71,3.02,5.15,6.7,7.03,11.06c3.95,9.18,2.76,17.12-2.9,23.45c-1.13,1.27-4.12,0.73-4.35-1.23 c-0.93-8.17-1.14-11.13-12.41-19.14c-2.77-1.97-5.83-3.27-8.8-5.03c1.12,7.58-0.84,13.32-3.2,14.12c0.91-4.74-5.44-8.02-9.22-8.87 c-1.61-0.36-3.26-1.05-4.86-2.04c0.05,15.61-7,26.26-11.42,26.24c3.36-5.99-3.74-13.38-8.47-16.28 c-4.69-2.88-8.89-8.18-11.25-15.31c1.17,4.75-3.05,9.89-7.25,11.33c1.06-2.19-1.51-6.19-4.92-11.94 c14.56-9.62,33.17-17.59,55.17-18.03l2.93,0.04c18.04,3.56,33,7.78,45.37,12.32C686.37,719.62,686.54,719.94,686.69,720.3z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3528_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3530_",
    className: "st2",
    d: "M565.96,758.66c-0.05,5.68,4.44,10.33,10.03,10.37c5.59,0.05,10.16-4.51,10.2-10.2 c0.04-5.67-4.44-10.32-10.03-10.37C570.58,748.41,566.01,752.98,565.96,758.66z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3527_",
    d: "M567.75,761.72c-0.01,2.34,1.82,4.24,4.12,4.26c2.28,0.03,4.16-1.86,4.19-4.18 c0.01-2.34-1.82-4.24-4.12-4.26C569.65,757.51,567.77,759.4,567.75,761.72z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3526_",
    className: "st2",
    d: "M572.95,760.1c0,0.51,0.38,0.91,0.87,0.92c0.5,0,0.91-0.4,0.91-0.9 c0-0.51-0.39-0.91-0.88-0.91C573.35,759.21,572.95,759.61,572.95,760.1z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3509_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3525_",
    className: "st11",
    d: "M646.65,739.21c0.01-2.43-1.56-4.56-3.99-5.83c1.46-0.73,3.19-1.15,5.07-1.13 c5.04,0.04,9.09,3.2,9.05,7.05c-0.03,3.84-4.12,6.93-9.16,6.89c-1.86-0.01-3.61-0.47-5.06-1.21 C645.01,743.73,646.62,741.61,646.65,739.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3524_",
    className: "st11",
    d: "M656.98,739.17c0.03-2.4-1.56-4.55-3.99-5.82c1.44-0.73,3.2-1.16,5.07-1.13 c5.04,0.04,9.09,3.2,9.06,7.05c-0.04,3.84-4.14,6.94-9.18,6.89c-1.86-0.01-3.61-0.47-5.06-1.21 C655.34,743.69,656.96,741.6,656.98,739.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3523_",
    className: "st11",
    d: "M667.2,739.26c0.03-2.42-1.56-4.55-3.99-5.83c1.44-0.72,3.2-1.15,5.07-1.12 c5.04,0.04,9.09,3.2,9.06,7.03c-0.04,3.86-4.14,6.94-9.18,6.9c-1.86-0.01-3.61-0.47-5.06-1.23 C665.56,743.78,667.17,741.68,667.2,739.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3522_",
    className: "st11",
    d: "M630.5,734.67c1.68-1.56,4.24-2.54,7.1-2.52c1.88,0.03,3.61,0.47,5.05,1.23 c2.43,1.27,4.01,3.4,3.99,5.83c-0.03,2.4-1.64,4.52-4.1,5.75c-1.46,0.73-3.2,1.15-5.07,1.13c-2.18-0.03-4.16-0.63-5.73-1.62 C631.93,741.18,631.51,737.85,630.5,734.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3521_",
    className: "st11",
    d: "M649.45,755.67c0.03-2.42-1.56-4.55-3.99-5.82c1.46-0.73,3.2-1.16,5.07-1.13 c5.04,0.04,9.1,3.2,9.06,7.05c-0.03,3.84-4.14,6.93-9.16,6.89c-1.88-0.01-3.62-0.47-5.06-1.21 C647.81,760.2,649.43,758.09,649.45,755.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3520_",
    className: "st11",
    d: "M659.68,755.77c0.01-2.42-1.58-4.55-4.01-5.83c1.46-0.72,3.2-1.15,5.08-1.13 c5.03,0.05,9.09,3.2,9.05,7.05c-0.03,3.86-4.14,6.94-9.16,6.9c-1.88-0.01-3.63-0.47-5.06-1.23 C658.02,760.29,659.65,758.18,659.68,755.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3519_",
    className: "st11",
    d: "M669.89,755.85c0.01-2.4-1.58-4.54-4-5.82c1.46-0.72,3.2-1.15,5.08-1.13 c5.03,0.04,9.09,3.2,9.05,7.06c-0.03,3.84-4.14,6.93-9.17,6.87c-1.88-0.01-3.62-0.45-5.06-1.21 C668.25,760.38,669.87,758.28,669.89,755.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3518_",
    className: "st11",
    d: "M633.31,751.15c1.68-1.56,4.24-2.55,7.09-2.52c1.88,0.03,3.61,0.47,5.05,1.23 c2.43,1.27,4.02,3.4,3.99,5.82c-0.01,2.41-1.64,4.52-4.08,5.76c-1.46,0.73-3.2,1.15-5.08,1.13c-2.18-0.03-4.16-0.63-5.73-1.61 C634.73,757.66,634.31,754.33,633.31,751.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3517_",
    className: "st11",
    d: "M647.67,769.83c0.03-2.42-1.56-4.56-3.99-5.83c1.46-0.73,3.2-1.15,5.08-1.13 c5.03,0.05,9.09,3.2,9.05,7.05c-0.04,3.86-4.14,6.94-9.18,6.89c-1.86-0.01-3.61-0.45-5.04-1.21 C646.03,774.35,647.66,772.25,647.67,769.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3516_",
    className: "st11",
    d: "M657.9,769.91c0.01-2.42-1.58-4.55-4-5.83c1.46-0.72,3.2-1.13,5.08-1.12 c5.03,0.04,9.09,3.2,9.05,7.05c-0.04,3.86-4.14,6.94-9.18,6.89c-1.86-0.01-3.61-0.47-5.04-1.21 C656.25,774.45,657.88,772.33,657.9,769.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3515_",
    className: "st11",
    d: "M668.12,770.01c0.01-2.42-1.58-4.55-4.01-5.83c1.46-0.72,3.2-1.15,5.08-1.12 c5.03,0.04,9.09,3.19,9.05,7.05c-0.03,3.84-4.14,6.93-9.18,6.89c-1.87-0.01-3.61-0.47-5.04-1.21 C666.46,774.53,668.09,772.42,668.12,770.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3514_",
    className: "st11",
    d: "M631.52,765.3c1.69-1.56,4.24-2.54,7.1-2.52c1.87,0.03,3.61,0.47,5.06,1.23 c2.43,1.27,4.02,3.42,3.99,5.83c-0.01,2.42-1.64,4.52-4.08,5.75c-1.46,0.73-3.2,1.15-5.08,1.13c-2.18-0.01-4.16-0.61-5.72-1.6 C632.96,771.81,632.53,768.48,631.52,765.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3513_",
    className: "st11",
    d: "M645.26,783.74c0.01-2.4-1.58-4.55-4.01-5.82c1.46-0.73,3.2-1.15,5.08-1.13 c5.03,0.04,9.09,3.2,9.05,7.05c-0.03,3.86-4.14,6.94-9.16,6.9c-1.88-0.03-3.61-0.47-5.06-1.23 C643.6,788.27,645.23,786.15,645.26,783.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3512_",
    className: "st11",
    d: "M655.47,783.83c0.01-2.41-1.58-4.55-3.99-5.82c1.44-0.73,3.19-1.16,5.07-1.13 c5.03,0.04,9.09,3.2,9.05,7.05c-0.03,3.84-4.14,6.93-9.16,6.89c-1.88-0.01-3.61-0.47-5.06-1.21 C653.83,788.35,655.45,786.25,655.47,783.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3511_",
    className: "st11",
    d: "M665.69,783.92c0.01-2.41-1.58-4.55-3.99-5.83c1.44-0.73,3.19-1.15,5.07-1.13 c5.03,0.05,9.09,3.2,9.05,7.05c-0.03,3.86-4.14,6.94-9.17,6.9c-1.88-0.03-3.61-0.47-5.06-1.23 C664.05,788.45,665.68,786.34,665.69,783.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3510_",
    className: "st11",
    d: "M629.11,779.21c1.68-1.56,4.24-2.55,7.09-2.52c1.88,0.03,3.61,0.47,5.05,1.23 c2.43,1.27,4.02,3.42,4.01,5.82c-0.03,2.41-1.65,4.54-4.1,5.76c-1.46,0.72-3.2,1.15-5.08,1.14c-2.17-0.03-4.16-0.63-5.71-1.62 C630.53,785.73,630.1,782.39,629.11,779.21z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3508_",
    className: "st12",
    d: "M619.46,726.12c18.91,19.54,18.65,50.92-0.59,70.14"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3469_"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3506_",
    className: "st5",
    d: "M348.82,446.31c0,0,58.91-29.64,72.54-16.03c9,8.98,9.27,20.67,9.27,20.67l-67.99,12.64 L348.82,446.31z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3505_",
    className: "st6",
    d: "M353.51,448.26c0,0,52.17-26.25,64.23-14.2c7.97,7.96,8.2,18.32,8.2,18.32l-60.2,11.18 L353.51,448.26z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3504_",
    className: "st5",
    d: "M348.38,516.93c0,0,34.75,16.73,42.59,8.63c5.17-5.35,5.22-12.19,5.22-12.19l-39.9-6.69 L348.38,516.93z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3503_",
    className: "st6",
    d: "M351.11,515.74c0,0,30.77,14.81,37.71,7.64c4.58-4.74,4.62-10.8,4.62-10.8l-35.33-5.92 L351.11,515.74z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3502_",
    className: "st5",
    d: "M414.69,535.42c-3.36-0.31-10.66-1.21-7.87-4.09c8.38-8.66,7.32-18.95-5.71-33.82 c11.19-10.2,24.28-14.55,32.84-11.28c4.86,11.18,5.04,23.03,3.42,28.31C434.33,524.38,426.97,536.56,414.69,535.42z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3501_",
    className: "st6",
    d: "M416,533.52c-2.83-0.26-8.96-1.01-6.62-3.44c7.05-7.29,6.16-15.93-4.79-28.45 c9.41-8.58,20.42-12.24,27.62-9.49c4.08,9.4,4.24,19.37,2.87,23.82C432.52,524.23,426.33,534.48,416,533.52z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3500_",
    className: "st5",
    d: "M347.92,506.69c-9.5-9.5-9.63-24.99-0.29-34.64l-16.16-7.98 c-13.72,14.18-13.52,36.93,0.43,50.87L347.92,506.69z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3499_",
    className: "st6",
    d: "M345.22,504.1c-8.07-8.06-8.19-21.23-0.25-29.42l-13.72-6.78 c-11.65,12.04-11.49,31.37,0.36,43.21L345.22,504.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3498_",
    className: "st5",
    d: "M475.1,482.15c0,0-26.19,37.12-67.49,37.48c-41.3,0.37-69.8-5.45-70.02-30.17 c-1.75-7.65,7.28-31.86,71.38-44.51C450.28,444.59,475.1,482.15,475.1,482.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.3855,
    y1: 524.3644,
    x2: 258.3855,
    y2: 449.6989,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 143.7472 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD58C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3325"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3497_",
    className: "st13",
    d: "M475.19,482.24c0,0-26.2,37.12-67.5,37.48c-41.31,0.37-69.8-5.45-70.01-30.17 c-1.75-7.65,7.27-31.87,71.36-44.51C450.36,444.68,475.19,482.24,475.19,482.24z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3494_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.0799,
    y1: 489.1041,
    x2: 236.0799,
    y2: 461.6607,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 143.7472 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD58C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3325"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3496_",
    className: "st14",
    d: "M420.14,465.8c-1.14,0.7-2.29,1.18-3.43,1.45c-2.65,0.59-7.12,2.9-6.49,6.23 c-1.65-0.55-3.03-4.59-2.25-9.93c-2.08,1.24-4.24,2.15-6.19,3.54c-7.93,5.63-8.07,7.73-8.73,13.47 c-0.16,1.37-2.25,1.75-3.06,0.85c-3.98-4.45-4.82-10.03-2.03-16.49c1.32-3.07,3.03-5.65,4.93-7.78c-0.8,0.02-1.62,0.05-2.42,0.07 c-0.04,0.02-0.06,0.05-0.1,0.07c-1.41,0.88-2.89,1.47-4.22,2.42c-4.98,3.54-5.07,4.85-5.48,8.46c-0.1,0.86-1.43,1.11-1.92,0.54 c-2.5-2.8-3.04-6.31-1.28-10.36c0.1-0.24,0.22-0.48,0.34-0.71c-3.45,1.28-6.62,2.57-9.52,3.9c-0.04,0.22-0.02,0.39,0.06,0.52 c-0.22-0.04-0.44-0.13-0.65-0.25c-0.77,0.36-1.52,0.71-2.24,1.07c-0.13,0.15-0.27,0.31-0.42,0.43c-0.79,0.67-1.9,2.22-1.13,3.24 c-0.51,0.07-1.34-0.61-1.98-1.85c-13.1,7.09-19.43,14.53-22.06,20.36l88.28-0.78C425.07,484.28,420.11,476.78,420.14,465.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.9633,
    y1: 485.5851,
    x2: 264.9633,
    y2: 450.1095,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 143.7472 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD58C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3325"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3493_",
    className: "st15",
    d: "M376.64,454.83c-1.75,4.06-1.23,7.57,1.28,10.35c0.5,0.56,1.83,0.33,1.92-0.53 c0.42-3.61,0.51-4.92,5.49-8.47c1.33-0.95,2.81-1.54,4.22-2.41c0.03-0.03,0.06-0.05,0.1-0.08c0.8-0.02,1.62-0.04,2.42-0.06 c-1.9,2.12-3.62,4.71-4.94,7.78c-2.78,6.46-1.94,12.05,2.04,16.5c0.79,0.89,2.9,0.52,3.06-0.86c0.66-5.75,0.8-7.83,8.73-13.46 c1.95-1.39,4.1-2.3,6.19-3.54c-0.79,5.33,0.59,9.37,2.25,9.93c-0.64-3.33,3.82-5.64,6.49-6.24c1.14-0.25,2.29-0.74,3.42-1.44 c-0.04,10.98,4.92,18.48,8.04,18.46c-2.36-4.22,2.63-9.42,5.96-11.45c3.3-2.03,6.25-5.76,7.92-10.77 c-0.82,3.34,2.14,6.96,5.1,7.97c-0.75-1.54,1.06-4.36,3.46-8.4c-10.24-6.77-23.34-12.37-38.82-12.68l-2.06,0.03 c-12.69,2.51-23.22,5.47-31.92,8.67C376.86,454.36,376.74,454.58,376.64,454.83z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3490_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3492_",
    className: "st2",
    d: "M461.58,481.83c0.04,4-3.12,7.27-7.06,7.29c-3.94,0.04-7.15-3.17-7.18-7.17 c-0.03-3.99,3.12-7.26,7.06-7.29C458.33,474.62,461.54,477.83,461.58,481.83z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3489_",
    d: "M460.32,483.98c0.01,1.64-1.28,2.99-2.9,3c-1.61,0.02-2.93-1.31-2.95-2.94 c-0.01-1.64,1.28-2.99,2.9-2.99C458.98,481.02,460.3,482.34,460.32,483.98z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3488_",
    className: "st2",
    d: "M456.66,482.84c0,0.36-0.27,0.64-0.61,0.65c-0.35,0-0.64-0.28-0.64-0.63 c0-0.36,0.28-0.64,0.62-0.64C456.38,482.21,456.66,482.49,456.66,482.84z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3471_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3487_",
    className: "st11",
    d: "M404.81,468.14c-0.01-1.71,1.1-3.21,2.81-4.1c-1.03-0.52-2.24-0.81-3.57-0.8 c-3.55,0.03-6.39,2.25-6.36,4.96c0.02,2.7,2.9,4.87,6.45,4.84c1.31-0.01,2.54-0.33,3.56-0.85 C405.96,471.32,404.83,469.83,404.81,468.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3486_",
    className: "st11",
    d: "M397.54,468.11c-0.02-1.69,1.1-3.2,2.81-4.09c-1.02-0.52-2.25-0.82-3.57-0.8 c-3.55,0.03-6.39,2.25-6.37,4.96c0.03,2.7,2.91,4.88,6.46,4.84c1.31-0.01,2.54-0.33,3.56-0.85 C398.69,471.29,397.56,469.82,397.54,468.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3485_",
    className: "st11",
    d: "M390.35,468.18c-0.02-1.7,1.1-3.2,2.81-4.1c-1.02-0.51-2.25-0.81-3.57-0.79 c-3.55,0.03-6.39,2.25-6.37,4.95c0.03,2.71,2.91,4.88,6.46,4.85c1.31-0.01,2.54-0.33,3.56-0.86 C391.51,471.36,390.37,469.87,390.35,468.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3484_",
    className: "st11",
    d: "M416.17,464.95c-1.18-1.1-2.98-1.78-5-1.77c-1.32,0.02-2.54,0.33-3.56,0.86 c-1.71,0.89-2.82,2.39-2.81,4.1c0.02,1.69,1.16,3.18,2.88,4.05c1.03,0.52,2.25,0.81,3.57,0.8c1.53-0.02,2.93-0.44,4.03-1.14 C415.17,469.53,415.46,467.18,416.17,464.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3483_",
    className: "st11",
    d: "M402.84,479.72c-0.02-1.7,1.1-3.2,2.81-4.09c-1.03-0.52-2.25-0.82-3.57-0.8 c-3.55,0.03-6.4,2.25-6.37,4.96c0.02,2.7,2.91,4.87,6.45,4.84c1.32-0.01,2.55-0.33,3.56-0.85 C404,482.91,402.85,481.42,402.84,479.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3482_",
    className: "st11",
    d: "M395.65,479.79c-0.01-1.7,1.11-3.2,2.82-4.1c-1.03-0.51-2.25-0.81-3.57-0.8 c-3.54,0.04-6.39,2.25-6.37,4.96c0.02,2.71,2.91,4.88,6.45,4.85c1.32-0.01,2.55-0.33,3.56-0.86 C396.81,482.97,395.66,481.49,395.65,479.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3481_",
    className: "st11",
    d: "M388.46,479.85c-0.01-1.69,1.11-3.19,2.82-4.09c-1.03-0.51-2.25-0.81-3.57-0.8 c-3.54,0.03-6.39,2.25-6.37,4.97c0.02,2.7,2.91,4.87,6.45,4.83c1.32-0.01,2.55-0.32,3.56-0.85 C389.61,483.04,388.48,481.55,388.46,479.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3480_",
    className: "st11",
    d: "M414.2,476.54c-1.18-1.1-2.98-1.79-4.99-1.77c-1.32,0.02-2.54,0.33-3.56,0.86 c-1.71,0.89-2.83,2.39-2.81,4.09c0.01,1.7,1.15,3.18,2.87,4.05c1.03,0.52,2.25,0.81,3.57,0.8c1.53-0.02,2.93-0.44,4.03-1.14 C413.2,481.12,413.49,478.77,414.2,476.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3479_",
    className: "st11",
    d: "M404.09,489.68c-0.02-1.7,1.1-3.21,2.81-4.1c-1.03-0.52-2.25-0.81-3.57-0.8 c-3.54,0.04-6.39,2.25-6.37,4.96c0.03,2.71,2.91,4.88,6.46,4.84c1.31-0.01,2.54-0.32,3.55-0.85 C405.24,492.87,404.1,491.38,404.09,489.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3478_",
    className: "st11",
    d: "M396.89,489.74c-0.01-1.7,1.11-3.2,2.82-4.1c-1.03-0.51-2.25-0.8-3.57-0.79 c-3.54,0.03-6.39,2.25-6.37,4.96c0.03,2.71,2.91,4.88,6.46,4.84c1.31-0.01,2.54-0.33,3.55-0.85 C398.06,492.93,396.91,491.44,396.89,489.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3477_",
    className: "st11",
    d: "M389.71,489.81c-0.01-1.7,1.11-3.2,2.82-4.1c-1.03-0.51-2.25-0.81-3.58-0.79 c-3.54,0.03-6.39,2.24-6.36,4.96c0.02,2.7,2.91,4.87,6.46,4.84c1.31-0.01,2.54-0.33,3.55-0.85 C390.87,492.99,389.72,491.5,389.71,489.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3476_",
    className: "st11",
    d: "M415.45,486.49c-1.19-1.1-2.98-1.78-5-1.77c-1.31,0.02-2.54,0.33-3.56,0.86 c-1.71,0.89-2.83,2.4-2.81,4.1c0.01,1.7,1.16,3.18,2.87,4.05c1.03,0.52,2.25,0.81,3.58,0.8c1.53-0.01,2.93-0.43,4.03-1.13 C414.44,491.07,414.74,488.74,415.45,486.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3475_",
    className: "st11",
    d: "M405.79,499.47c-0.01-1.69,1.11-3.2,2.82-4.09c-1.03-0.52-2.25-0.81-3.58-0.8 c-3.54,0.03-6.39,2.25-6.36,4.96c0.02,2.71,2.91,4.88,6.45,4.85c1.32-0.02,2.54-0.33,3.56-0.86 C406.95,502.66,405.81,501.17,405.79,499.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3474_",
    className: "st11",
    d: "M398.6,499.53c-0.01-1.7,1.11-3.2,2.81-4.09c-1.02-0.52-2.24-0.82-3.57-0.8 c-3.54,0.03-6.39,2.25-6.37,4.96c0.02,2.7,2.91,4.87,6.45,4.85c1.32-0.01,2.54-0.33,3.56-0.85 C399.76,502.71,398.62,501.23,398.6,499.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3473_",
    className: "st11",
    d: "M391.41,499.6c-0.01-1.7,1.11-3.2,2.81-4.1c-1.02-0.52-2.24-0.81-3.57-0.8 c-3.54,0.04-6.39,2.25-6.37,4.96c0.02,2.71,2.91,4.88,6.45,4.85c1.32-0.02,2.54-0.33,3.56-0.86 C392.57,502.78,391.42,501.3,391.41,499.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3472_",
    className: "st11",
    d: "M417.15,496.28c-1.18-1.1-2.98-1.79-4.99-1.77c-1.32,0.02-2.54,0.33-3.56,0.86 c-1.71,0.89-2.83,2.4-2.82,4.09c0.02,1.7,1.16,3.19,2.88,4.05c1.03,0.51,2.25,0.81,3.57,0.8c1.52-0.02,2.93-0.44,4.02-1.14 C416.15,500.87,416.45,498.52,417.15,496.28z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3470_",
    className: "st12",
    d: "M423.94,458.93c-13.3,13.74-13.12,35.82,0.42,49.34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3431_"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3468_",
    className: "st16",
    d: "M408.24,125.73c0,0-42.6-21.43-52.46-11.59c-6.51,6.5-6.7,14.95-6.7,14.95l49.17,9.14 L408.24,125.73z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3467_",
    className: "st17",
    d: "M404.84,127.14c0,0-37.73-18.98-46.45-10.27c-5.77,5.76-5.93,13.25-5.93,13.25l43.53,8.09 L404.84,127.14z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3466_",
    className: "st16",
    d: "M408.55,176.8c0,0-25.13,12.1-30.8,6.24c-3.74-3.87-3.77-8.81-3.77-8.81l28.85-4.84 L408.55,176.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3465_",
    className: "st17",
    d: "M406.58,175.94c0,0-22.25,10.71-27.27,5.53c-3.31-3.43-3.34-7.81-3.34-7.81l25.55-4.28 L406.58,175.94z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3464_",
    className: "st16",
    d: "M360.6,190.18c2.43-0.22,7.71-0.88,5.69-2.96c-6.06-6.26-5.29-13.7,4.13-24.46 c-8.09-7.38-17.56-10.52-23.75-8.16c-3.51,8.09-3.65,16.65-2.47,20.48C346.39,182.19,351.72,191,360.6,190.18z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3463_",
    className: "st17",
    d: "M359.65,188.8c2.04-0.19,6.48-0.73,4.79-2.49c-5.1-5.27-4.46-11.52,3.47-20.57 c-6.81-6.21-14.76-8.85-19.98-6.86c-2.95,6.8-3.07,14.01-2.08,17.22C347.7,182.08,352.18,189.49,359.65,188.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3462_",
    className: "st16",
    d: "M408.89,169.4c6.87-6.87,6.96-18.07,0.21-25.05l11.68-5.77 c9.92,10.25,9.78,26.71-0.31,36.79L408.89,169.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3461_",
    className: "st17",
    d: "M410.84,167.53c5.84-5.83,5.92-15.35,0.18-21.28l9.92-4.9c8.42,8.71,8.31,22.69-0.26,31.25 L410.84,167.53z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3460_",
    className: "st16",
    d: "M316.91,151.65c0,0,18.94,26.85,48.81,27.1c29.87,0.26,50.48-3.94,50.63-21.82 c1.26-5.53-5.26-23.04-51.62-32.19C334.86,124.49,316.91,151.65,316.91,151.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -1606.2316,
    y1: 167.4282,
    x2: -1606.2316,
    y2: 113.4305,
    gradientTransform: "matrix(-1 -8.600000e-03 -8.600000e-03 1 -1238.3728 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3459_",
    className: "st18",
    d: "M316.84,151.71c0,0,18.95,26.85,48.82,27.1c29.88,0.26,50.48-3.94,50.63-21.82 c1.26-5.53-5.26-23.05-51.61-32.19C334.8,124.55,316.84,151.71,316.84,151.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3456_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: -1622.3629,
    y1: 141.9281,
    x2: -1622.3629,
    y2: 122.0812,
    gradientTransform: "matrix(-1 -8.600000e-03 -8.600000e-03 1 -1238.3728 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    className: "st19",
    d: "M356.65,139.83c0.82,0.5,1.66,0.86,2.48,1.05c1.92,0.43,5.15,2.1,4.69,4.51 c1.2-0.4,2.19-3.32,1.63-7.18c1.5,0.9,3.07,1.56,4.48,2.56c5.73,4.07,5.84,5.59,6.31,9.74c0.11,0.99,1.63,1.26,2.21,0.62 c2.88-3.22,3.49-7.25,1.47-11.93c-0.96-2.22-2.19-4.09-3.57-5.63c0.58,0.01,1.17,0.03,1.75,0.05c0.03,0.01,0.05,0.03,0.07,0.05 c1.02,0.64,2.09,1.07,3.05,1.75c3.6,2.56,3.67,3.51,3.96,6.12c0.07,0.62,1.04,0.8,1.39,0.39c1.81-2.02,2.2-4.56,0.93-7.5 c-0.07-0.18-0.16-0.35-0.25-0.52c2.49,0.92,4.78,1.86,6.88,2.82c0.03,0.16,0.01,0.29-0.05,0.37c0.16-0.03,0.32-0.1,0.47-0.18 c0.55,0.26,1.1,0.52,1.62,0.77c0.09,0.11,0.19,0.22,0.3,0.31c0.57,0.48,1.38,1.61,0.81,2.34c0.37,0.05,0.97-0.44,1.43-1.34 c9.47,5.13,14.05,10.51,15.95,14.73l-63.84-0.56C353.09,153.19,356.68,147.77,356.65,139.83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: -1601.4745,
    y1: 139.3832,
    x2: -1601.4745,
    y2: 113.7274,
    gradientTransform: "matrix(-1 -8.600000e-03 -8.600000e-03 1 -1238.3728 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3455_",
    className: "st20",
    d: "M388.11,131.9c1.27,2.93,0.89,5.47-0.92,7.49c-0.36,0.41-1.32,0.24-1.39-0.39 c-0.3-2.61-0.37-3.56-3.97-6.12c-0.96-0.69-2.03-1.11-3.05-1.75c-0.02-0.02-0.05-0.03-0.07-0.05c-0.58-0.01-1.17-0.03-1.75-0.04 c1.38,1.53,2.62,3.41,3.57,5.63c2.01,4.67,1.4,8.71-1.48,11.93c-0.57,0.64-2.1,0.37-2.21-0.63c-0.47-4.15-0.58-5.66-6.31-9.74 c-1.41-1-2.97-1.66-4.48-2.56c0.57,3.86-0.43,6.78-1.63,7.18c0.46-2.41-2.77-4.08-4.69-4.51c-0.82-0.18-1.66-0.54-2.47-1.04 c0.03,7.94-3.56,13.36-5.81,13.35c1.71-3.05-1.9-6.81-4.31-8.28c-2.38-1.47-4.52-4.16-5.73-7.79c0.59,2.42-1.55,5.03-3.69,5.76 c0.54-1.11-0.77-3.15-2.51-6.08c7.41-4.9,16.88-8.95,28.07-9.17l1.49,0.02c9.18,1.81,16.79,3.96,23.08,6.27 C387.95,131.55,388.04,131.71,388.11,131.9z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3452_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3454_",
    className: "st2",
    d: "M326.69,151.42c-0.03,2.89,2.26,5.26,5.1,5.28c2.85,0.03,5.17-2.29,5.19-5.19 c0.02-2.89-2.26-5.25-5.1-5.28C329.04,146.2,326.72,148.52,326.69,151.42z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3451_",
    d: "M327.6,152.97c-0.01,1.19,0.93,2.16,2.1,2.17c1.16,0.01,2.12-0.94,2.13-2.13 c0.01-1.19-0.93-2.16-2.1-2.17C328.57,150.83,327.61,151.79,327.6,152.97z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3450_",
    className: "st2",
    d: "M330.24,152.15c0,0.26,0.19,0.46,0.44,0.47c0.25,0,0.46-0.2,0.46-0.46 c0-0.26-0.2-0.46-0.45-0.46C330.45,151.69,330.24,151.9,330.24,152.15z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3433_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3449_",
    className: "st11",
    d: "M367.74,141.52c0.01-1.24-0.8-2.32-2.03-2.97c0.74-0.37,1.62-0.58,2.58-0.58 c2.57,0.02,4.62,1.63,4.6,3.58c-0.01,1.96-2.1,3.52-4.66,3.5c-0.95-0.01-1.84-0.24-2.57-0.62 C366.91,143.82,367.73,142.74,367.74,141.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3448_",
    className: "st11",
    d: "M373,141.5c0.01-1.22-0.79-2.32-2.03-2.96c0.73-0.37,1.63-0.59,2.58-0.58 c2.57,0.02,4.62,1.63,4.61,3.58c-0.02,1.96-2.1,3.53-4.67,3.5c-0.95-0.01-1.84-0.24-2.57-0.62 C372.17,143.8,372.99,142.73,373,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3447_",
    className: "st11",
    d: "M378.2,141.54c0.01-1.23-0.79-2.32-2.03-2.97c0.73-0.37,1.63-0.58,2.58-0.57 c2.57,0.02,4.62,1.63,4.61,3.58c-0.02,1.96-2.1,3.53-4.67,3.51c-0.95-0.01-1.84-0.24-2.57-0.62 C377.37,143.85,378.19,142.77,378.2,141.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3446_",
    className: "st11",
    d: "M359.53,139.21c0.86-0.79,2.16-1.29,3.61-1.28c0.96,0.01,1.84,0.24,2.57,0.62 c1.24,0.65,2.04,1.73,2.03,2.97c-0.01,1.22-0.84,2.3-2.08,2.93c-0.74,0.37-1.63,0.58-2.58,0.58c-1.11-0.01-2.12-0.32-2.91-0.82 C360.26,142.52,360.04,140.82,359.53,139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3445_",
    className: "st11",
    d: "M369.17,149.9c0.01-1.23-0.8-2.32-2.03-2.96c0.74-0.37,1.63-0.59,2.58-0.58 c2.57,0.02,4.63,1.63,4.61,3.58c-0.01,1.96-2.1,3.52-4.66,3.5c-0.96-0.01-1.84-0.24-2.57-0.62 C368.33,152.2,369.16,151.12,369.17,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3444_",
    className: "st11",
    d: "M374.37,149.94c0.01-1.23-0.8-2.32-2.04-2.97c0.74-0.37,1.63-0.58,2.59-0.58 c2.56,0.03,4.62,1.63,4.6,3.59c-0.01,1.96-2.1,3.53-4.66,3.51c-0.96-0.01-1.84-0.24-2.57-0.62 C373.53,152.24,374.36,151.17,374.37,149.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3443_",
    className: "st11",
    d: "M379.57,149.98c0.01-1.22-0.8-2.31-2.04-2.96c0.74-0.37,1.63-0.58,2.59-0.58 c2.56,0.02,4.62,1.63,4.6,3.59c-0.01,1.96-2.11,3.52-4.66,3.5c-0.96-0.01-1.84-0.23-2.57-0.62 C378.73,152.29,379.56,151.22,379.57,149.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3442_",
    className: "st11",
    d: "M360.96,147.59c0.86-0.79,2.16-1.3,3.61-1.28c0.96,0.01,1.84,0.24,2.57,0.63 c1.24,0.65,2.04,1.73,2.03,2.96c-0.01,1.23-0.83,2.3-2.08,2.93c-0.74,0.37-1.63,0.58-2.59,0.58c-1.11-0.01-2.12-0.32-2.91-0.82 C361.68,150.91,361.46,149.21,360.96,147.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3441_",
    className: "st11",
    d: "M368.27,157.1c0.01-1.23-0.79-2.32-2.03-2.97c0.74-0.37,1.63-0.58,2.59-0.58 c2.56,0.03,4.62,1.63,4.6,3.59c-0.02,1.96-2.1,3.53-4.67,3.5c-0.95-0.01-1.84-0.23-2.57-0.62 C367.43,159.4,368.26,158.33,368.27,157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3440_",
    className: "st11",
    d: "M373.47,157.14c0.01-1.23-0.8-2.32-2.04-2.97c0.74-0.37,1.63-0.58,2.59-0.57 c2.56,0.02,4.62,1.63,4.6,3.58c-0.02,1.96-2.11,3.53-4.67,3.5c-0.95-0.01-1.84-0.24-2.57-0.62 C372.63,159.45,373.46,158.37,373.47,157.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3439_",
    className: "st11",
    d: "M378.67,157.19c0.01-1.23-0.8-2.32-2.04-2.97c0.74-0.37,1.63-0.58,2.59-0.57 c2.56,0.02,4.62,1.62,4.6,3.58c-0.01,1.96-2.1,3.52-4.67,3.5c-0.95-0.01-1.84-0.24-2.57-0.62 C377.83,159.49,378.65,158.42,378.67,157.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3438_",
    className: "st11",
    d: "M360.05,154.79c0.86-0.79,2.16-1.29,3.61-1.28c0.95,0.01,1.84,0.24,2.57,0.62 c1.24,0.65,2.04,1.74,2.03,2.97c-0.01,1.23-0.84,2.3-2.08,2.93c-0.74,0.37-1.63,0.58-2.59,0.58c-1.11-0.01-2.12-0.31-2.91-0.81 C360.78,158.1,360.56,156.41,360.05,154.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3437_",
    className: "st11",
    d: "M367.04,164.17c0.01-1.22-0.8-2.32-2.04-2.96c0.74-0.37,1.63-0.58,2.59-0.58 c2.56,0.02,4.62,1.63,4.6,3.58c-0.01,1.96-2.1,3.53-4.66,3.51c-0.96-0.01-1.84-0.24-2.57-0.63 C366.19,166.48,367.02,165.4,367.04,164.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3436_",
    className: "st11",
    d: "M372.23,164.22c0.01-1.23-0.8-2.32-2.03-2.96c0.73-0.37,1.62-0.59,2.58-0.58 c2.56,0.02,4.62,1.63,4.6,3.58c-0.01,1.96-2.1,3.52-4.66,3.5c-0.96-0.01-1.84-0.24-2.57-0.62 C371.4,166.52,372.22,165.45,372.23,164.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3435_",
    className: "st11",
    d: "M377.43,164.27c0.01-1.23-0.8-2.32-2.03-2.97c0.73-0.37,1.62-0.58,2.58-0.58 c2.56,0.03,4.62,1.63,4.6,3.58c-0.01,1.96-2.11,3.53-4.66,3.51c-0.96-0.01-1.84-0.24-2.57-0.63 C376.6,166.57,377.43,165.5,377.43,164.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3434_",
    className: "st11",
    d: "M358.82,161.87c0.86-0.79,2.16-1.3,3.61-1.28c0.96,0.01,1.84,0.24,2.57,0.63 c1.24,0.65,2.04,1.74,2.04,2.96c-0.01,1.23-0.84,2.31-2.08,2.93c-0.74,0.37-1.63,0.58-2.59,0.58c-1.1-0.01-2.12-0.32-2.91-0.82 C359.54,165.19,359.33,163.49,358.82,161.87z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3432_",
    className: "st12",
    d: "M353.91,134.86c9.62,9.94,9.49,25.91-0.3,35.69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st16",
    d: "M948.92,337.14c0,0,91.93-46.25,113.19-25.01c14.04,14.02,14.46,32.26,14.46,32.26 l-106.1,19.72L948.92,337.14z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st17",
    d: "M956.24,340.19c0,0,81.41-40.96,100.23-22.15c12.44,12.42,12.8,28.58,12.8,28.58 l-93.93,17.45L956.24,340.19z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st16",
    d: "M948.24,447.34c0,0,54.23,26.11,66.46,13.46c8.07-8.35,8.15-19.01,8.15-19.01l-62.26-10.45 L948.24,447.34z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st17",
    d: "M952.49,445.48c0,0,48.02,23.12,58.85,11.92c7.15-7.4,7.21-16.85,7.21-16.85l-55.12-9.24 L952.49,445.48z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st16",
    d: "M1051.72,476.2c-5.25-0.48-16.64-1.89-12.28-6.39c13.07-13.51,11.42-29.56-8.91-52.77 c17.46-15.92,37.88-22.71,51.25-17.61c7.58,17.45,7.87,35.94,5.34,44.18C1082.37,458.97,1070.88,477.98,1051.72,476.2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st17",
    d: "M1053.75,473.23c-4.41-0.41-13.98-1.58-10.34-5.36c11-11.37,9.62-24.86-7.48-44.39 c14.69-13.39,31.86-19.1,43.1-14.81c6.37,14.66,6.62,30.22,4.48,37.17C1079.54,458.74,1069.87,474.72,1053.75,473.23z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st16",
    d: "M947.52,431.37c-14.82-14.83-15.02-39-0.45-54.06l-25.21-12.45 c-21.41,22.12-21.1,57.63,0.68,79.39L947.52,431.37z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st17",
    d: "M943.3,427.33c-12.6-12.58-12.77-33.12-0.39-45.91l-21.41-10.58 c-18.18,18.8-17.93,48.96,0.56,67.43L943.3,427.33z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st16",
    d: "M1145.98,393.08c0,0-40.87,57.93-105.32,58.48c-64.45,0.57-108.93-8.51-109.26-47.08 c-2.72-11.94,11.36-49.72,111.39-69.46C1107.25,334.46,1145.98,393.08,1145.98,393.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: -2255.0862,
    y1: 434.7301,
    x2: -2255.0862,
    y2: 318.2157,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 3290.501 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st21",
    d: "M1146.13,393.21c0,0-40.88,57.93-105.34,58.48c-64.47,0.57-108.93-8.51-109.24-47.09 c-2.73-11.94,11.34-49.74,111.36-69.46C1107.38,334.6,1146.13,393.21,1146.13,393.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2289.8938,
    y1: 379.7069,
    x2: -2289.8938,
    y2: 336.8819,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 3290.501 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1060.22,367.56c-1.77,1.08-3.58,1.85-5.35,2.26c-4.14,0.92-11.12,4.53-10.12,9.73 c-2.58-0.86-4.73-7.16-3.52-15.5c-3.24,1.94-6.62,3.36-9.66,5.52c-12.37,8.79-12.6,12.06-13.62,21.02 c-0.25,2.14-3.52,2.72-4.77,1.33c-6.21-6.94-7.53-15.65-3.17-25.74c2.06-4.79,4.73-8.82,7.7-12.14c-1.25,0.03-2.52,0.07-3.78,0.1 c-0.06,0.03-0.1,0.07-0.16,0.1c-2.21,1.38-4.51,2.3-6.59,3.78c-7.77,5.52-7.91,7.57-8.55,13.2c-0.16,1.35-2.23,1.73-3,0.85 c-3.91-4.37-4.74-9.84-2-16.17c0.16-0.38,0.35-0.75,0.53-1.11c-5.38,1.99-10.32,4.01-14.85,6.09c-0.06,0.34-0.03,0.62,0.1,0.81 c-0.35-0.06-0.69-0.21-1.01-0.39c-1.2,0.56-2.36,1.11-3.5,1.67c-0.2,0.23-0.42,0.48-0.65,0.67c-1.24,1.04-2.97,3.47-1.76,5.05 c-0.79,0.12-2.09-0.95-3.09-2.89c-20.44,11.06-30.32,22.68-34.42,31.78l137.76-1.22C1067.91,396.39,1060.17,384.7,1060.22,367.56 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: -2244.8218,
    y1: 374.2156,
    x2: -2244.8218,
    y2: 318.8564,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 3290.501 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st23",
    d: "M992.34,350.45c-2.74,6.33-1.92,11.81,1.99,16.16c0.78,0.88,2.85,0.51,3-0.83 c0.65-5.64,0.79-7.68,8.56-13.22c2.08-1.48,4.38-2.4,6.59-3.77c0.04-0.04,0.1-0.07,0.16-0.12c1.25-0.03,2.52-0.06,3.78-0.09 c-2.97,3.31-5.65,7.35-7.71,12.14c-4.34,10.08-3.03,18.8,3.19,25.74c1.24,1.39,4.53,0.81,4.77-1.35 c1.02-8.97,1.25-12.22,13.62-21.01c3.04-2.17,6.4-3.59,9.66-5.52c-1.23,8.32,0.92,14.62,3.52,15.5c-0.99-5.2,5.97-8.8,10.12-9.74 c1.77-0.4,3.58-1.16,5.33-2.24c-0.06,17.14,7.68,28.83,12.54,28.8c-3.69-6.58,4.11-14.69,9.3-17.87 c5.15-3.17,9.76-8.98,12.35-16.8c-1.28,5.22,3.34,10.86,7.96,12.44c-1.17-2.4,1.66-6.8,5.41-13.11 c-15.99-10.56-36.41-19.31-60.58-19.79l-3.22,0.04c-19.81,3.91-36.23,8.54-49.81,13.52C992.69,349.7,992.5,350.05,992.34,350.45z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1124.88,392.56c0.06,6.24-4.87,11.34-11.01,11.38c-6.14,0.06-11.16-4.95-11.2-11.19 c-0.04-6.23,4.87-11.32,11.01-11.38C1119.8,381.31,1124.82,386.32,1124.88,392.56z"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    d: "M1122.92,395.92c0.01,2.56-2,4.66-4.53,4.67c-2.51,0.03-4.57-2.04-4.6-4.59c-0.01-2.56,2-4.66,4.53-4.67 C1120.83,391.3,1122.89,393.37,1122.92,395.92z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st2",
    d: "M1117.21,394.15c0,0.56-0.42,1-0.95,1.01c-0.55,0-0.99-0.44-0.99-0.98c0-0.56,0.43-1,0.97-1 C1116.76,393.17,1117.21,393.6,1117.21,394.15z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st11",
    d: "M1036.29,371.21c-0.01-2.67,1.72-5.01,4.38-6.4c-1.6-0.81-3.5-1.26-5.57-1.25 c-5.54,0.04-9.98,3.52-9.93,7.73c0.03,4.22,4.53,7.6,10.06,7.56c2.05-0.01,3.96-0.51,5.55-1.33 C1038.1,376.17,1036.32,373.84,1036.29,371.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st11",
    d: "M1024.95,371.16c-0.03-2.64,1.72-5,4.38-6.39c-1.59-0.81-3.52-1.28-5.56-1.25 c-5.54,0.04-9.98,3.51-9.95,7.73c0.04,4.22,4.54,7.62,10.08,7.56c2.05-0.02,3.97-0.51,5.55-1.33 C1026.75,376.13,1024.98,373.83,1024.95,371.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st11",
    d: "M1013.73,371.26c-0.03-2.65,1.72-5,4.38-6.4c-1.59-0.79-3.52-1.26-5.56-1.23 c-5.54,0.04-9.98,3.52-9.95,7.72c0.04,4.23,4.54,7.62,10.08,7.57c2.05-0.01,3.96-0.51,5.55-1.35 C1015.53,376.23,1013.76,373.91,1013.73,371.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st11",
    d: "M1054.03,366.22c-1.85-1.71-4.66-2.78-7.8-2.77c-2.06,0.03-3.96,0.51-5.55,1.35 c-2.67,1.39-4.4,3.74-4.38,6.4c0.03,2.64,1.8,4.97,4.5,6.31c1.6,0.81,3.52,1.26,5.56,1.25c2.39-0.03,4.57-0.69,6.29-1.77 C1052.45,373.37,1052.92,369.71,1054.03,366.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st11",
    d: "M1033.22,389.28c-0.03-2.65,1.72-5,4.38-6.39c-1.6-0.81-3.52-1.28-5.57-1.25 c-5.54,0.04-9.99,3.51-9.95,7.73c0.03,4.22,4.54,7.6,10.06,7.56c2.06-0.02,3.98-0.51,5.55-1.33 C1035.02,394.25,1033.24,391.93,1033.22,389.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st11",
    d: "M1021.99,389.39c-0.01-2.65,1.73-5,4.4-6.4c-1.6-0.79-3.52-1.26-5.58-1.25 c-5.52,0.06-9.98,3.52-9.93,7.74c0.03,4.23,4.54,7.62,10.06,7.57c2.06-0.01,3.98-0.51,5.55-1.35 C1023.81,394.35,1022.02,392.04,1021.99,389.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st11",
    d: "M1010.78,389.47c-0.01-2.64,1.73-4.98,4.4-6.39c-1.6-0.79-3.52-1.26-5.58-1.25 c-5.52,0.04-9.98,3.51-9.93,7.75c0.03,4.22,4.54,7.6,10.06,7.54c2.06-0.02,3.98-0.5,5.55-1.33 C1012.58,394.46,1010.81,392.14,1010.78,389.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st11",
    d: "M1050.94,384.32c-1.85-1.71-4.66-2.8-7.79-2.77c-2.06,0.03-3.96,0.51-5.55,1.35 c-2.67,1.39-4.41,3.74-4.38,6.39c0.01,2.65,1.8,4.97,4.48,6.33c1.6,0.81,3.52,1.26,5.58,1.25c2.39-0.03,4.57-0.69,6.29-1.77 C1049.38,391.47,1049.84,387.8,1050.94,384.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st11",
    d: "M1035.17,404.83c-0.03-2.65,1.72-5.01,4.38-6.4c-1.6-0.81-3.52-1.26-5.58-1.25 c-5.52,0.06-9.98,3.52-9.93,7.74c0.04,4.23,4.54,7.62,10.08,7.56c2.05-0.01,3.97-0.5,5.54-1.33 C1036.97,409.79,1035.18,407.48,1035.17,404.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st11",
    d: "M1023.94,404.92c-0.01-2.65,1.73-5,4.4-6.4c-1.6-0.79-3.52-1.25-5.58-1.23 c-5.52,0.04-9.98,3.51-9.93,7.73c0.04,4.23,4.54,7.62,10.08,7.56c2.05-0.02,3.96-0.51,5.54-1.33 C1025.76,409.9,1023.97,407.57,1023.94,404.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st11",
    d: "M1012.72,405.02c-0.01-2.65,1.73-5,4.4-6.4c-1.6-0.79-3.52-1.26-5.58-1.23 c-5.52,0.04-9.98,3.5-9.93,7.73c0.03,4.22,4.54,7.6,10.08,7.56c2.05-0.01,3.96-0.51,5.54-1.33 C1014.54,409.98,1012.75,407.67,1012.72,405.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st11",
    d: "M1052.9,399.85c-1.86-1.71-4.66-2.78-7.8-2.77c-2.05,0.03-3.96,0.51-5.55,1.35 c-2.67,1.39-4.41,3.75-4.38,6.4c0.01,2.65,1.8,4.97,4.48,6.31c1.6,0.81,3.52,1.26,5.58,1.25c2.39-0.02,4.57-0.67,6.28-1.76 C1051.33,407,1051.79,403.35,1052.9,399.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st11",
    d: "M1037.82,420.09c-0.01-2.64,1.73-5,4.4-6.39c-1.6-0.81-3.52-1.26-5.58-1.25 c-5.52,0.04-9.98,3.52-9.93,7.73c0.03,4.23,4.54,7.62,10.06,7.57c2.06-0.03,3.96-0.51,5.55-1.35 C1039.64,425.07,1037.85,422.74,1037.82,420.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st11",
    d: "M1026.61,420.2c-0.01-2.65,1.73-5,4.38-6.39c-1.59-0.81-3.5-1.27-5.56-1.25 c-5.52,0.04-9.98,3.52-9.93,7.73c0.03,4.22,4.54,7.6,10.06,7.56c2.06-0.02,3.96-0.51,5.55-1.33 C1028.41,425.16,1026.64,422.85,1026.61,420.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st11",
    d: "M1015.39,420.3c-0.01-2.65,1.73-5,4.38-6.4c-1.59-0.81-3.5-1.26-5.56-1.25 c-5.52,0.06-9.98,3.52-9.93,7.73c0.03,4.23,4.54,7.62,10.06,7.57c2.06-0.03,3.96-0.51,5.55-1.35 C1017.19,425.26,1015.4,422.95,1015.39,420.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st11",
    d: "M1055.55,415.13c-1.85-1.71-4.66-2.8-7.79-2.77c-2.06,0.03-3.96,0.51-5.55,1.35 c-2.67,1.39-4.41,3.75-4.4,6.39c0.03,2.65,1.82,4.98,4.5,6.33c1.6,0.79,3.52,1.26,5.58,1.25c2.38-0.03,4.57-0.69,6.27-1.77 C1054,422.28,1054.46,418.61,1055.55,415.13z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st12",
    d: "M1066.15,356.83c-20.76,21.45-20.47,55.9,0.65,77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3354_",
    className: "st24"
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3430_",
    className: "st16",
    d: "M385.53,658.16c0,0,28.83-14.51,35.5-7.84c4.4,4.4,4.54,10.12,4.54,10.12l-33.28,6.18 L385.53,658.16z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3429_",
    className: "st17",
    d: "M387.83,659.12c0,0,25.53-12.85,31.44-6.95c3.9,3.9,4.02,8.96,4.02,8.96l-29.46,5.47 L387.83,659.12z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3428_",
    className: "st16",
    d: "M385.32,692.73c0,0,17.01,8.19,20.84,4.22c2.53-2.62,2.55-5.96,2.55-5.96l-19.53-3.28 L385.32,692.73z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3427_",
    className: "st17",
    d: "M386.65,692.14c0,0,15.06,7.25,18.46,3.74c2.24-2.32,2.26-5.28,2.26-5.28l-17.29-2.9 L386.65,692.14z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3426_",
    className: "st16",
    d: "M417.77,701.78c-1.65-0.15-5.22-0.59-3.85-2c4.1-4.24,3.58-9.27-2.79-16.55 c5.48-4.99,11.88-7.12,16.07-5.52c2.38,5.47,2.47,11.27,1.67,13.86C427.38,696.37,423.78,702.33,417.77,701.78z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3425_",
    className: "st17",
    d: "M418.41,700.85c-1.38-0.13-4.39-0.5-3.24-1.68c3.45-3.57,3.02-7.8-2.35-13.92 c4.61-4.2,9.99-5.99,13.52-4.65c2,4.6,2.08,9.48,1.41,11.66C426.5,696.3,423.46,701.31,418.41,700.85z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3424_",
    className: "st16",
    d: "M385.09,687.72c-4.65-4.65-4.71-12.23-0.14-16.96l-7.91-3.91 c-6.71,6.94-6.62,18.08,0.21,24.9L385.09,687.72z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3423_",
    className: "st17",
    d: "M383.77,686.45c-3.95-3.95-4.01-10.39-0.12-14.4l-6.71-3.32 c-5.7,5.9-5.62,15.36,0.18,21.15L383.77,686.45z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3422_",
    className: "st16",
    d: "M447.34,675.71c0,0-12.82,18.17-33.03,18.34c-20.22,0.18-34.16-2.67-34.27-14.77 c-0.85-3.74,3.56-15.6,34.94-21.78C435.19,657.32,447.34,675.71,447.34,675.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 2047.7213,
    y1: 714.1221,
    x2: 2047.7213,
    y2: 677.5782,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 -1640.0315 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3421_",
    className: "st25",
    d: "M447.38,675.75c0,0-12.82,18.17-33.04,18.34c-20.22,0.18-34.16-2.67-34.26-14.77 c-0.85-3.74,3.56-15.6,34.93-21.78C435.23,657.36,447.38,675.75,447.38,675.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3418_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 2036.8042,
    y1: 696.8645,
    x2: 2036.8042,
    y2: 683.4327,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 -1640.0315 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3420_",
    className: "st26",
    d: "M420.44,667.7c-0.56,0.34-1.12,0.58-1.68,0.71c-1.3,0.29-3.49,1.42-3.17,3.05 c-0.81-0.27-1.48-2.25-1.1-4.86c-1.02,0.61-2.08,1.05-3.03,1.73c-3.88,2.76-3.95,3.78-4.27,6.59c-0.08,0.67-1.1,0.85-1.5,0.42 c-1.95-2.18-2.36-4.91-0.99-8.07c0.65-1.5,1.48-2.77,2.41-3.81c-0.39,0.01-0.79,0.02-1.18,0.03c-0.02,0.01-0.03,0.02-0.05,0.03 c-0.69,0.43-1.42,0.72-2.07,1.19c-2.44,1.73-2.48,2.38-2.68,4.14c-0.05,0.42-0.7,0.54-0.94,0.27c-1.23-1.37-1.49-3.09-0.63-5.07 c0.05-0.12,0.11-0.23,0.17-0.35c-1.69,0.62-3.24,1.26-4.66,1.91c-0.02,0.11-0.01,0.19,0.03,0.25c-0.11-0.02-0.22-0.06-0.32-0.12 c-0.38,0.17-0.74,0.35-1.1,0.52c-0.06,0.07-0.13,0.15-0.2,0.21c-0.39,0.33-0.93,1.09-0.55,1.59c-0.25,0.04-0.66-0.3-0.97-0.91 c-6.41,3.47-9.51,7.11-10.8,9.97l43.21-0.38C422.85,676.74,420.42,673.08,420.44,667.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 2050.9407,
    y1: 695.1422,
    x2: 2050.9407,
    y2: 677.7791,
    gradientTransform: "matrix(1 -8.600000e-03 8.600000e-03 1 -1640.0315 -2.4169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A298",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A456A1"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3417_",
    className: "st27",
    d: "M399.15,662.34c-0.86,1.99-0.6,3.7,0.62,5.07c0.24,0.28,0.9,0.16,0.94-0.26 c0.2-1.77,0.25-2.41,2.69-4.14c0.65-0.46,1.37-0.75,2.07-1.18c0.01-0.01,0.03-0.02,0.05-0.04c0.39-0.01,0.79-0.02,1.18-0.03 c-0.93,1.04-1.77,2.31-2.42,3.81c-1.36,3.16-0.95,5.9,1,8.07c0.39,0.44,1.42,0.25,1.5-0.42c0.32-2.81,0.39-3.83,4.27-6.59 c0.95-0.68,2.01-1.13,3.03-1.73c-0.38,2.61,0.29,4.59,1.1,4.86c-0.31-1.63,1.87-2.76,3.17-3.06c0.56-0.12,1.12-0.36,1.67-0.7 c-0.02,5.38,2.41,9.04,3.93,9.03c-1.16-2.06,1.29-4.61,2.92-5.61c1.61-0.99,3.06-2.82,3.87-5.27c-0.4,1.64,1.05,3.41,2.5,3.9 c-0.37-0.75,0.52-2.13,1.7-4.11c-5.01-3.31-11.42-6.06-19-6.21l-1.01,0.01c-6.21,1.23-11.36,2.68-15.62,4.24 C399.26,662.1,399.2,662.21,399.15,662.34z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3375_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3416_",
    className: "st2",
    d: "M440.72,675.55c0.02,1.96-1.53,3.56-3.45,3.57c-1.93,0.02-3.5-1.55-3.51-3.51 c-0.01-1.95,1.53-3.55,3.45-3.57C439.13,672.02,440.7,673.59,440.72,675.55z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3377_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M453.01,675.43c-0.01-4.02-1.69-8.13-4.6-11.03c-1.45-1.46-3.2-2.65-5.15-3.46 c-1.95-0.81-4.09-1.22-6.17-1.2c-2.07,0.02-4.2,0.47-6.13,1.31c-1.93,0.84-3.66,2.06-5.08,3.55c-2.86,2.94-4.46,7.08-4.41,11.1 c0.01,4.02,1.69,8.16,4.61,11.05c1.45,1.46,3.21,2.65,5.16,3.46c1.94,0.81,4.1,1.21,6.14,1.19c2.05-0.01,4.2-0.46,6.13-1.3 c1.94-0.84,3.67-2.06,5.1-3.55C451.46,683.6,453.07,679.45,453.01,675.43l-15.97,0.15c0.3,0.04,0.09,0.05,0.39,0 c-0.26-0.04-0.11-0.05-0.39,0L453.01,675.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.25,675.7L437.25,675.7L437.25,675.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M442.54,684.08c0-0.09,0.06-0.29,0.2-0.04C442.68,684.11,442.6,684.07,442.54,684.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M442.98,684.25c-0.06-0.12,0.11-0.09,0.14-0.15C443.21,684.24,443.05,684.3,442.98,684.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M442.05,681.78c-0.03-0.09-0.01-0.2,0.09-0.13C442.22,681.76,442.07,681.73,442.05,681.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M443.99,683.64c-0.05-0.16,0-0.28,0.15-0.35C444.22,683.47,444.06,683.54,443.99,683.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.18,675.61C437.18,675.61,437.18,675.61,437.18,675.61C437.18,675.61,437.18,675.6,437.18,675.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M439.54,677.71c-0.22-0.28,0.16-0.11,0.02-0.32c0.24,0.17-0.04,0.12,0.13,0.28 c-0.03,0-0.08-0.02-0.13-0.04C439.56,677.66,439.69,677.8,439.54,677.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M440.78,677.45c-0.14-0.07-0.23-0.12-0.2-0.14c0.05,0.02,0.13,0.05,0.22,0.1L440.78,677.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M439.05,676.32c-0.24-0.13-0.24-0.19-0.02-0.17c-0.03-0.02-0.13-0.04-0.11-0.05 c-0.03-0.03,0.09-0.05,0.07-0.01C439.16,676.22,438.95,676.21,439.05,676.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M441.88,677.35c-0.08-0.05-0.09-0.09-0.07-0.13C441.94,677.28,441.94,677.36,441.88,677.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.16,675.59L437.16,675.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M440.96,676.92c-0.14-0.08-0.07-0.12-0.17-0.18C441.02,676.78,440.95,676.87,440.96,676.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M441.78,677.14c-0.17-0.08-0.09-0.13-0.1-0.2C441.81,677.02,441.74,677.07,441.78,677.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.16,675.59L437.16,675.59L437.16,675.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.16,675.59c-0.01,0-0.01,0-0.01,0C437.16,675.59,437.16,675.59,437.16,675.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M441.69,676.92c-0.25-0.14-0.02-0.17,0.02-0.22C441.85,676.8,441.54,676.81,441.69,676.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M439.01,676.06c-0.1-0.03-0.11-0.05-0.15-0.08C439.12,676.04,439,676.04,439.01,676.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M439.62,676.16c-0.14-0.05-0.07-0.05-0.03-0.06C439.72,676.13,439.59,676.14,439.62,676.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M440.36,676.25c-0.15-0.04-0.17-0.11,0.14-0.04c0.02,0.02-0.09,0-0.18-0.02 C440.28,676.21,440.42,676.24,440.36,676.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.12,675.58C437.13,675.58,437.14,675.59,437.12,675.58L437.12,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.11,675.58c-0.01,0-0.01,0-0.01,0C437.11,675.58,437.11,675.58,437.11,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.11,675.58L437.11,675.58L437.11,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.1,675.58c-0.01,0-0.02,0-0.02,0C437.1,675.58,437.09,675.58,437.1,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.05,675.58C437.04,675.58,437.03,675.58,437.05,675.58L437.05,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.17,675.59L437.17,675.59L437.17,675.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.16,675.59L437.16,675.59L437.16,675.59L437.16,675.59c-0.02,0-0.01,0-0.02,0 C437.15,675.59,437.17,675.59,437.16,675.59L437.16,675.59L437.16,675.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M440.94,676.7c-0.01-0.01-0.06-0.02-0.06-0.02c-0.13-0.04-0.02-0.05,0.02-0.05 C441.06,676.69,440.93,676.8,440.94,676.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M440.42,675.87l0.24,0.02c-0.01-0.06-0.06-0.16,0.16-0.19c0.16,0.09-0.25,0.21,0.11,0.3 c-0.06,0.01-0.07,0.03-0.13,0.03c0.35,0.23-0.08,0.36,0.1,0.59c-0.6-0.23,0.3-0.22-0.33-0.44c0.04-0.01,0.06,0.01,0.06,0.02 C440.63,676.13,440.8,675.99,440.42,675.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.11,675.58L437.11,675.58L437.11,675.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M437.17,675.56L437.17,675.56L437.17,675.56L437.17,675.56L437.17,675.56c0,0-0.01,0.01-0.01,0.01 s0,0-0.01,0l0,0c-0.02,0-0.05,0.01-0.06,0.01c0,0-0.01,0-0.02,0l-0.01,0h0h0l0.25-0.01c0.4-0.01,0.78-0.02,1.07-0.01 c0.19-0.01,0.24-0.01,0.36-0.01c1.49-0.01,2.75-0.08,3.91-0.07c0.68-0.12,1.47-0.13,2.11-0.26c0.4-0.09,0.77-0.26,1.14-0.39 c0.43-0.15,0.76-0.32,1.18-0.49c0.45-0.05,0.51-0.24,0.88-0.33c0.24-0.26,0.59-0.51,0.81-0.81c0.14-0.05,0.22-0.13,0.4-0.18 c0.63-0.69,1.4-1.55,1.36-2.49c0-0.08-0.02-0.26-0.06-0.35c-0.25-0.6-0.56-1.56-0.23-2.17c-0.02-0.13-0.15-0.05-0.17-0.19 c0.21-0.21,0.47-0.82,0.27-1.09c-0.07-0.09-0.5-0.04-0.7-0.19c-0.29-0.23-0.09-0.82-0.37-1.04c-0.13-0.1-0.5,0.01-0.66-0.05 c-0.42-0.17-0.88-0.85-1.06-1.17c-0.13-0.25-0.03-0.54-0.22-0.63c-0.18-0.08-0.49,0.07-0.77,0.44 c-0.52,0.23-0.9,0.01-1.29-0.28c-0.38-0.28-0.79-0.62-1.23-0.62c-0.33-0.6-1.09-0.29-1.55-0.55c-0.09-0.05-0.17-0.22-0.28-0.25 c-0.18-0.06-0.48,0.04-0.72,0.03c-0.42-0.01-0.75-0.12-1.1-0.04c-0.36-0.71-0.88-0.09-1.27-0.18 c-0.15-0.03-0.28-0.24-0.46-0.26c-0.15-0.02-0.31,0.15-0.47,0.12c-0.16-0.02-0.32-0.22-0.48-0.22c-0.12,0-0.21,0.11-0.31,0.1 c-0.12-0.02-0.2-0.16-0.34-0.14c-0.14,0.03-0.27,0.27-0.41,0.3c-0.49,0.12-1.07-0.08-1.48,0.45c-0.92-0.23-1.5,0.53-2.57,0.5 c-0.2,0.2-0.33,0.35-0.62,0.34c-0.04,0.06,0.02,0.19-0.07,0.22c-0.55,0.06-0.81,0.75-1.35,0.84c0.02,0.07,0.04,0.14,0.03,0.19 c-0.77,0.12-1.55,0.67-1.74,1.3c-0.52,0.07-0.67,0.67-1,1.06c-0.16,0.19-0.45,0.27-0.55,0.49c-0.18,0.43-0.66,0.83-0.82,1.24 c-0.05,0.12,0.03,0.32-0.01,0.44c-0.07,0.22-0.34,0.35-0.38,0.61c-0.12,0.98-0.7,1.86-0.9,2.66c-0.06,0.24,0.08,0.5,0.09,0.78 c0.04,0.46-0.35,0.88-0.31,1.35c0.01,0.12,0.12,0.23,0.14,0.34c0.05,0.27-0.07,0.52-0.06,0.81c0.04,0.71,0.43,1.34,0.28,2.03 c0.52,0.75,0.74,1.92,1.22,2.77c0.39,0.05,0.22,0.36,0.36,0.54c0.44,0.55,1.2,1.04,1.43,1.73c1.14,0.96,2.32,1.83,3.64,2.46 c1.32,0.62,2.8,0.96,4.18,0.76c0.19,0.27,0.53,0.13,0.72-0.04c0.03,0.16,0.16,0.15,0.25,0.2c0.33-0.39,0.75-0.1,1.17-0.23 c0.06-0.4,0.35-0.14,0.46-0.46c0.1,0.2-0.06,0.2,0.07,0.29c0.15-0.72,1.07-0.6,1.39-0.92c-0.03,0.01-0.06-0.09-0.04-0.11 c0.14,0.14,0.07-0.21,0.17-0.24c0.64-0.31,0.77-1.16,1.08-1.64c0.1,0.05,0.42,0.21,0.33-0.04c-0.1,0.02-0.2,0.1-0.34-0.16 c0.18,0,0.28-0.22,0.24-0.47c0.14-0.12,0.3-0.06,0.3-0.33c0.03-0.02-0.21-0.22-0.15-0.26c0.29-0.03,0.22-0.3,0.48-0.34 c-0.14-0.25-0.02-0.47,0.14-0.42c-0.04-0.13-0.22-0.11-0.23-0.2c0.07-0.19,0.09-0.39,0.34-0.4c-0.07-0.12-0.19-0.25-0.18-0.33 c0.01-0.05,0.2,0.18,0.18,0.08c-0.08-0.15-0.25-0.14-0.4-0.28c-0.02-0.13-0.15-0.2-0.25-0.34c0.2,0.01-0.03-0.25-0.05-0.39 c-0.03-0.14,0.12-0.17,0.1-0.29c-0.02-0.11-0.18-0.25-0.13-0.32c0.04-0.06,0.25,0,0.28-0.08c-0.02-0.06-0.21-0.08-0.19-0.14 c0.06-0.27,0.11-0.55-0.18-0.85c0.33,0.44-0.21,0.43,0.04,0.84c-0.25-0.1,0.09,0.19-0.25,0.03c0.12,0.09,0.25,0.1,0.2,0.14 c-0.03,0.01-0.09-0.02-0.09,0.01c-0.26-0.2-0.28-0.15-0.48-0.25c-0.08,0.18-0.06,0.39-0.16,0.54c0.04,0.07,0.16,0.09,0.18,0.16 c0,0.09-0.08,0.1-0.06,0.22c-0.2-0.14-0.32-0.17-0.53-0.4c0.18-0.16-0.03-0.68,0.05-0.9c0.02-0.07,0.27-0.02-0.04-0.24 c0.05,0.15-0.36,0.01-0.43,0.05c-0.1,0.06,0.14,0.37,0.01,0.41c-0.04,0.01-0.13-0.05-0.15-0.03c-0.01,0.02,0.1,0.16,0.07,0.17 c-0.03,0.01-0.13-0.07-0.13-0.05c-0.01,0.05,0.11,0.21,0.07,0.25c-0.07,0.06-0.29-0.04-0.31,0.08 c-0.09-0.07-0.26-0.27-0.28-0.31c0.08-0.06,0.09-0.08,0.14-0.17c-0.03-0.01-0.07-0.04-0.14-0.11c0.03-0.01,0.1,0.03,0-0.08 c-0.04,0.06-0.37-0.27-0.51-0.43c0.16-0.05,0.09-0.31,0.29-0.3c-0.1-0.08-0.24-0.18-0.27-0.22c-0.07-0.17,0.12-0.2,0.03-0.37 c-0.38-0.03-0.23,0.14-0.2,0.35c-0.05-0.03-0.18-0.13-0.16-0.09c0.1,0.14,0.03,0.18,0.04,0.25c-0.21-0.15-0.42-0.31-0.64-0.49 c0.05,0.11-0.14-0.01-0.31-0.17c-0.18-0.15-0.36-0.37-0.36-0.36c-0.08-0.12-0.11-0.15-0.17-0.23l0-0.01c0,0,0,0-0.01-0.01 c-0.01-0.01-0.03-0.03-0.03-0.03l0,0c0.01,0,0,0,0.01,0.01c0,0,0,0,0,0c-0.01-0.01-0.01-0.01-0.01-0.01 c-0.01,0,0.01,0-0.05-0.01c0.04,0.01,0.04,0.01,0.05,0.01l0,0c0,0,0,0,0,0c0.01,0,0,0,0.01,0l0,0l0.01,0.01c0,0,0,0,0.01,0.01 l0,0l0,0l0,0c0,0,0,0,0.01,0.01c0.01,0.01,0.02,0.02,0.03,0.04l0,0.01l0,0l0,0l0.01,0.02c0,0.01,0.01,0.02,0.01,0.01l0,0 c0-0.03-0.01-0.06-0.01-0.08l0,0.01l0,0.01l0,0.01c0,0.05-0.01,0.07,0,0.04c0.01-0.02,0.02-0.04,0.04-0.06 c0.01-0.01,0.01-0.01,0.03-0.03c0,0,0.01,0,0.01,0l0.01,0c0,0,0,0,0,0l0.01,0c0.01,0,0.03,0,0.04-0.01c0,0,0.06-0.01,0.08,0 c0.01,0-0.02,0-0.03,0c-0.01,0-0.03,0-0.03,0c-0.01,0-0.03,0-0.04-0.01c-0.02,0-0.01,0-0.01,0l0,0 c-0.02-0.01-0.01-0.01-0.02-0.01l0,0c-0.02-0.02-0.03-0.03-0.04-0.06c-0.01-0.01-0.01-0.02-0.01-0.02 c0-0.01-0.01-0.01-0.01-0.01l0,0c0-0.01,0,0,0,0c0-0.01,0,0.02,0,0.02s0.01,0.11,0,0.03c0-0.05,0.01-0.08,0.01-0.07 c0,0,0-0.01,0,0c-0.01,0.02-0.01,0.02-0.01,0.02c0,0.01-0.01,0.02-0.01,0.03c-0.01,0.01,0,0-0.03,0.04 c-0.01,0.02-0.01,0.02-0.01,0.02l0,0C437.17,675.55,437.17,675.56,437.17,675.56L437.17,675.56z M441.42,679.8 c0.05,0.05,0.08,0.07,0.1,0.07C441.69,680.1,441.34,679.86,441.42,679.8z M441.36,679.69c0.08-0.11-0.01-0.43,0.22-0.36 c0.02-0.02-0.27-0.21-0.31-0.28c0.15,0.06,0.28,0.08,0.34,0.01c0.4,0.3,0.04,0.27,0.37,0.56c-0.08,0.03-0.13,0.05,0.02,0.23 c-0.23,0.01-0.03,0.25-0.24,0.22C441.57,679.84,441.58,679.93,441.36,679.69z"
  }))))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3374_",
    d: "M440.1,676.6c0,0.8-0.63,1.46-1.42,1.47c-0.79,0.01-1.43-0.64-1.44-1.44c0-0.8,0.63-1.46,1.42-1.47 C439.45,675.15,440.09,675.8,440.1,676.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3373_",
    className: "st2",
    d: "M438.31,676.04c0,0.17-0.13,0.31-0.3,0.32c-0.17,0-0.31-0.14-0.31-0.31 c0-0.17,0.14-0.31,0.3-0.31C438.17,675.73,438.31,675.87,438.31,676.04z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3356_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3372_",
    className: "st29",
    d: "M412.93,668.85c0-0.84,0.54-1.57,1.37-2.01c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.74,0.01-3.13,1.1-3.12,2.43c0.01,1.32,1.42,2.39,3.16,2.37c0.64,0,1.24-0.16,1.74-0.42 C413.5,670.4,412.94,669.67,412.93,668.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3371_",
    className: "st29",
    d: "M409.38,668.83c-0.01-0.83,0.54-1.57,1.37-2c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.74,0.01-3.13,1.1-3.12,2.43c0.01,1.32,1.42,2.39,3.16,2.37c0.64,0,1.24-0.16,1.74-0.42 C409.94,670.39,409.39,669.67,409.38,668.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3370_",
    className: "st29",
    d: "M405.86,668.86c-0.01-0.83,0.54-1.57,1.37-2.01c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.74,0.01-3.13,1.1-3.12,2.42c0.01,1.33,1.42,2.39,3.16,2.38c0.64,0,1.24-0.16,1.74-0.42 C406.42,670.42,405.87,669.7,405.86,668.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3369_",
    className: "st29",
    d: "M418.5,667.28c-0.58-0.54-1.46-0.87-2.45-0.87c-0.65,0.01-1.24,0.16-1.74,0.42 c-0.84,0.44-1.38,1.17-1.37,2.01c0.01,0.83,0.57,1.56,1.41,1.98c0.5,0.25,1.1,0.4,1.75,0.39c0.75-0.01,1.43-0.22,1.97-0.56 C418,669.53,418.15,668.38,418.5,667.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3368_",
    className: "st29",
    d: "M411.97,674.52c-0.01-0.83,0.54-1.57,1.37-2c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.74,0.01-3.13,1.1-3.12,2.43c0.01,1.32,1.42,2.38,3.16,2.37c0.65,0,1.25-0.16,1.74-0.42 C412.54,676.07,411.98,675.35,411.97,674.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3367_",
    className: "st29",
    d: "M408.45,674.55c0-0.83,0.54-1.57,1.38-2.01c-0.5-0.25-1.1-0.39-1.75-0.39 c-1.73,0.02-3.13,1.1-3.12,2.43c0.01,1.33,1.42,2.39,3.16,2.38c0.65,0,1.25-0.16,1.74-0.42 C409.02,676.11,408.46,675.38,408.45,674.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3366_",
    className: "st29",
    d: "M404.93,674.58c0-0.83,0.54-1.56,1.38-2c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.73,0.01-3.13,1.1-3.12,2.43c0.01,1.32,1.42,2.38,3.16,2.37c0.65,0,1.25-0.16,1.74-0.42 C405.5,676.14,404.94,675.41,404.93,674.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3365_",
    className: "st29",
    d: "M417.53,672.96c-0.58-0.54-1.46-0.88-2.44-0.87c-0.65,0.01-1.24,0.16-1.74,0.42 c-0.84,0.44-1.38,1.17-1.37,2c0,0.83,0.56,1.56,1.41,1.98c0.5,0.25,1.1,0.4,1.75,0.39c0.75-0.01,1.43-0.22,1.97-0.56 C417.04,675.2,417.18,674.05,417.53,672.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3364_",
    className: "st29",
    d: "M412.58,679.39c-0.01-0.83,0.54-1.57,1.37-2.01c-0.5-0.25-1.1-0.39-1.75-0.39 c-1.73,0.02-3.13,1.1-3.12,2.43c0.01,1.33,1.42,2.39,3.16,2.37c0.64,0,1.24-0.16,1.74-0.42 C413.15,680.95,412.59,680.22,412.58,679.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3363_",
    className: "st29",
    d: "M409.06,679.42c0-0.83,0.54-1.57,1.38-2.01c-0.5-0.25-1.1-0.39-1.75-0.39 c-1.73,0.01-3.13,1.1-3.12,2.43c0.01,1.33,1.42,2.39,3.16,2.37c0.64,0,1.24-0.16,1.74-0.42 C409.63,680.98,409.07,680.25,409.06,679.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3362_",
    className: "st29",
    d: "M405.54,679.45c0-0.83,0.54-1.57,1.38-2.01c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.73,0.01-3.13,1.1-3.12,2.43c0.01,1.32,1.42,2.39,3.16,2.37c0.64,0,1.24-0.16,1.74-0.42 C406.11,681.01,405.55,680.28,405.54,679.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3361_",
    className: "st29",
    d: "M418.14,677.83c-0.58-0.54-1.46-0.87-2.45-0.87c-0.64,0.01-1.24,0.16-1.74,0.42 c-0.84,0.44-1.38,1.18-1.37,2.01c0,0.83,0.57,1.56,1.41,1.98c0.5,0.25,1.1,0.4,1.75,0.39c0.75,0,1.43-0.21,1.97-0.55 C417.65,680.07,417.79,678.93,418.14,677.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3360_",
    className: "st29",
    d: "M413.41,684.18c0-0.83,0.54-1.57,1.38-2c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.73,0.01-3.13,1.1-3.12,2.43c0.01,1.33,1.42,2.39,3.16,2.38c0.65-0.01,1.24-0.16,1.74-0.42 C413.98,685.74,413.42,685.01,413.41,684.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3359_",
    className: "st29",
    d: "M409.9,684.21c0-0.83,0.54-1.57,1.37-2c-0.5-0.25-1.1-0.4-1.74-0.39 c-1.73,0.01-3.13,1.1-3.12,2.43c0.01,1.32,1.42,2.39,3.16,2.37c0.65,0,1.24-0.16,1.74-0.42 C410.46,685.77,409.91,685.04,409.9,684.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3358_",
    className: "st29",
    d: "M406.38,684.24c0-0.83,0.54-1.57,1.37-2.01c-0.5-0.25-1.1-0.4-1.75-0.39 c-1.73,0.02-3.13,1.1-3.12,2.43c0.01,1.33,1.42,2.39,3.16,2.38c0.65-0.01,1.24-0.16,1.74-0.42 C406.94,685.8,406.38,685.08,406.38,684.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3357_",
    className: "st29",
    d: "M418.98,682.62c-0.58-0.54-1.46-0.88-2.44-0.87c-0.65,0.01-1.24,0.16-1.74,0.42 c-0.84,0.44-1.38,1.18-1.38,2c0.01,0.83,0.57,1.56,1.41,1.98c0.5,0.25,1.1,0.4,1.75,0.39c0.75-0.01,1.43-0.22,1.97-0.56 C418.49,684.86,418.63,683.71,418.98,682.62z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3355_",
    className: "st30",
    d: "M422.3,664.34c-6.51,6.73-6.42,17.53,0.2,24.15"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3661_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3665_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3667_",
    className: "st2",
    d: "M462.95,706.44c0,0-0.05,0.96-0.15,2.77c-0.03,0.46-0.03,0.95-0.1,1.52 c-0.09,0.57-0.18,1.2-0.28,1.88c-0.11,0.67-0.2,1.41-0.35,2.17c-0.19,0.75-0.4,1.55-0.61,2.39c-0.92,3.33-2.39,7.35-5.06,11.4 c-2.62,4.05-6.32,8.21-11.24,11.56c-4.94,3.3-11.07,5.75-17.83,6.52c-0.84,0.13-1.7,0.1-2.56,0.16l-1.29,0.06l-0.65,0.03 c-0.3,0-0.45-0.02-0.68-0.03c-1.7-0.12-3.41-0.12-5.2-0.49c-3.58-0.47-7.03-1.64-10.4-3.13c-0.83-0.41-1.65-0.82-2.49-1.24 c-0.81-0.45-1.59-0.98-2.38-1.46c-0.39-0.25-0.8-0.49-1.19-0.75l-1.12-0.86c-0.73-0.59-1.52-1.12-2.21-1.77 c-2.87-2.48-5.36-5.43-7.5-8.64c-2.1-3.24-3.67-6.84-4.83-10.56c-1.1-3.75-1.56-7.67-1.65-11.58l0.14-2.92 c0.01-0.96,0.16-1.94,0.31-2.91l0.22-1.46c0.06-0.49,0.14-0.97,0.28-1.44l0.71-2.84c1.16-3.72,2.72-7.32,4.83-10.56 c2.14-3.21,4.63-6.16,7.5-8.64c0.69-0.65,1.48-1.18,2.21-1.77l1.12-0.86c0.39-0.26,0.79-0.5,1.19-0.75 c0.8-0.49,1.57-1.02,2.38-1.46c0.83-0.41,1.66-0.83,2.49-1.24c3.36-1.49,6.84-2.66,10.38-3.13c1.75-0.36,3.52-0.37,5.25-0.49 c0.24-0.01,0.39-0.03,0.69-0.03l0.64,0.03l1.26,0.06c0.85,0.06,1.66,0.02,2.52,0.16c6.83,0.78,12.91,3.22,17.87,6.53 c4.93,3.35,8.62,7.51,11.24,11.56c2.67,4.05,4.14,8.07,5.06,11.4c0.22,0.84,0.42,1.64,0.61,2.39c0.15,0.76,0.24,1.48,0.35,2.14 c0.1,0.67,0.2,1.28,0.28,1.85c0.08,0.57,0.07,1.09,0.11,1.55c0.1,1.86,0.15,2.85,0.15,2.85L462.95,706.44z M460.67,706.38 c0,0-0.04-0.94-0.13-2.7c-0.03-0.44-0.02-0.93-0.09-1.47c-0.08-0.54-0.17-1.12-0.26-1.75c-0.1-0.63-0.17-1.31-0.32-2.03 c-0.18-0.71-0.37-1.46-0.57-2.26c-0.85-3.16-2.22-6.97-4.73-10.82c-2.46-3.86-5.95-7.79-10.57-11.06 c-4.62-3.2-10.48-5.62-16.85-6.45c-0.79-0.14-1.65-0.12-2.48-0.19l-1.26-0.07l-0.63-0.04l-0.58,0.02 c-1.66,0.09-3.36,0.07-5.04,0.4c-3.4,0.4-6.76,1.47-10.02,2.86c-0.8,0.38-1.61,0.77-2.41,1.16c-0.79,0.42-1.54,0.92-2.32,1.38 c-0.38,0.24-0.78,0.46-1.16,0.71l-1.09,0.82c-0.72,0.56-1.49,1.06-2.17,1.68c-2.81,2.37-5.22,5.23-7.32,8.33 c-2.06,3.14-3.6,6.62-4.75,10.23c-1.09,3.65-1.56,7.41-1.67,11.26c0.11,3.81,0.58,7.61,1.67,11.26 c1.15,3.61,2.69,7.09,4.75,10.23c2.1,3.09,4.52,5.96,7.32,8.33c0.68,0.62,1.45,1.12,2.17,1.68l1.09,0.82 c0.38,0.25,0.77,0.47,1.16,0.71c0.78,0.46,1.53,0.96,2.32,1.38c0.81,0.39,1.61,0.77,2.41,1.16c3.25,1.39,6.64,2.47,10,2.86 c1.64,0.33,3.4,0.31,5.09,0.4c0.19,0.01,0.47,0.03,0.59,0.02l0.62-0.04l1.24-0.07c0.82-0.07,1.64-0.05,2.44-0.19 c6.44-0.84,12.25-3.25,16.89-6.46c4.62-3.27,8.11-7.2,10.57-11.06c2.51-3.85,3.87-7.66,4.73-10.82c0.2-0.8,0.39-1.55,0.57-2.26 c0.14-0.71,0.21-1.38,0.31-2c0.09-0.62,0.18-1.2,0.26-1.72c0.07-0.53,0.06-1.05,0.09-1.5c0.08-1.81,0.13-2.77,0.13-2.77 L460.67,706.38z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3664_",
    className: "st4",
    d: "M424.1,731.22c-4.36-1.83-8.89-4.41-11.23-7.87c-5.52-7.13,8.9-8.28,10.7-14.62 c2.68-7.72-7.64-11.42-14.32-11.16c-2.65,0.07-5.25,0.41-7.75,1.03c-6.57,1.63-10.97,7.92-10.08,14.64 c0.11,0.86,0.26,1.72,0.45,2.58c3.66,16.8,20.02,27.51,36.57,23.91c12.54-2.73,21.57-12.9,23.61-24.98 c-4.48,2.74-8.43,7.79-12.29,11.87C435.65,731.48,429.84,733.93,424.1,731.22z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3663_",
    className: "st3",
    cx: 439.89,
    cy: 690.82,
    r: 2.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3662_",
    className: "st3",
    d: "M442.82,691.76c-0.95,4.52,2.16,12.38,2.98,16.93c0.11,0.58,0.19,1.19,0.03,1.77 c-0.11,0.4-0.33,0.76-0.54,1.11c-3.5,5.73-7.71,8.08-11.21,13.81c5.55-2.39,10.59-5.9,14.87-10.16c1.82-1.82,3.63-4.18,3.15-6.71 c-0.19-1-0.73-1.9-1.26-2.77c-2.67-4.45-5.22-8.97-7.64-13.57L442.82,691.76z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3680_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3684_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3686_",
    className: "st2",
    d: "M798.34,276.41c0,0-0.02,0.42-0.07,1.21c0,0.39-0.07,0.89-0.17,1.48 c-0.05,0.29-0.09,0.62-0.16,0.95c-0.08,0.33-0.17,0.68-0.27,1.04c-0.41,1.46-1.05,3.21-2.22,4.98c-1.15,1.77-2.77,3.57-4.91,5.04 c-2.15,1.45-4.83,2.52-7.78,2.87c-0.74,0.07-1.48,0.11-2.26,0.1c-0.75-0.05-1.49-0.05-2.27-0.21c-1.57-0.2-3.08-0.71-4.55-1.36 c-1.48-0.65-2.84-1.6-4.11-2.65c-1.26-1.08-2.34-2.38-3.28-3.79c-0.92-1.42-1.6-3-2.1-4.63c-0.48-1.64-0.68-3.36-0.71-5.07 c0.03-1.69,0.23-3.42,0.71-5.07c0.5-1.63,1.18-3.2,2.1-4.63c0.94-1.4,2.02-2.7,3.28-3.79c1.27-1.06,2.63-2,4.11-2.65 c2.93-1.35,6.16-1.79,9.07-1.47c2.99,0.35,5.64,1.42,7.8,2.87c2.14,1.47,3.77,3.28,4.91,5.04c1.17,1.77,1.82,3.52,2.22,4.98 c0.09,0.37,0.18,0.72,0.27,1.04c0.07,0.33,0.11,0.65,0.15,0.94c0.1,0.58,0.17,1.08,0.17,1.49c0.04,0.81,0.07,1.25,0.07,1.25 L798.34,276.41z M797.34,276.38c0,0-0.02-0.41-0.05-1.18c0-0.39-0.06-0.86-0.15-1.41c-0.04-0.28-0.08-0.57-0.14-0.89 c-0.08-0.31-0.16-0.64-0.25-0.99c-0.37-1.38-0.96-3.05-2.06-4.74c-1.07-1.69-2.6-3.42-4.63-4.84c-2.03-1.4-4.59-2.45-7.38-2.81 c-2.85-0.34-5.9,0.05-8.75,1.32c-1.43,0.61-2.75,1.51-3.99,2.52c-1.22,1.03-2.28,2.28-3.2,3.63c-0.9,1.37-1.58,2.89-2.08,4.46 c-0.48,1.59-0.69,3.24-0.74,4.92c0.05,1.67,0.26,3.33,0.74,4.92c0.51,1.58,1.18,3.1,2.08,4.46c0.92,1.35,1.98,2.59,3.2,3.63 c1.24,1.01,2.56,1.9,3.99,2.52c1.42,0.61,2.9,1.09,4.36,1.26c0.72,0.14,1.49,0.14,2.23,0.18c0.7,0,1.44-0.05,2.14-0.12 c2.82-0.36,5.36-1.41,7.4-2.81c2.03-1.42,3.55-3.15,4.63-4.84c1.09-1.69,1.69-3.36,2.06-4.74c0.09-0.35,0.17-0.68,0.25-0.99 c0.06-0.31,0.09-0.6,0.13-0.88c0.09-0.54,0.15-1.01,0.15-1.41c0.04-0.79,0.05-1.21,0.05-1.21L797.34,276.38z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3683_",
    className: "st4",
    d: "M781.35,287.24c-1.91-0.8-3.89-1.93-4.91-3.44c-2.41-3.12,3.89-3.62,4.68-6.39 c1.17-3.38-3.34-4.99-6.26-4.88c-1.16,0.03-2.29,0.18-3.39,0.45c-2.87,0.71-4.8,3.46-4.41,6.4c0.05,0.37,0.12,0.75,0.2,1.13 c1.6,7.35,8.75,12.03,15.99,10.46c5.48-1.19,9.43-5.64,10.32-10.92c-1.96,1.2-3.69,3.41-5.37,5.19 C786.4,287.35,783.86,288.43,781.35,287.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3682_",
    className: "st3",
    cx: 788.25,
    cy: 269.58,
    r: 1.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3681_",
    className: "st3",
    d: "M789.54,269.99c-0.42,1.98,0.94,5.41,1.3,7.4c0.05,0.26,0.08,0.52,0.01,0.77 c-0.05,0.17-0.14,0.33-0.24,0.49c-1.53,2.51-3.37,3.53-4.9,6.04c2.43-1.04,4.63-2.58,6.5-4.44c0.8-0.8,1.59-1.83,1.38-2.93 c-0.08-0.44-0.32-0.83-0.55-1.21c-1.17-1.95-2.28-3.92-3.34-5.93L789.54,269.99z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3689_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3693_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3695_",
    className: "st2",
    d: "M475.34,784.41c0,0-0.02,0.42-0.07,1.21c0,0.39-0.07,0.89-0.17,1.48 c-0.05,0.29-0.09,0.62-0.16,0.95c-0.08,0.33-0.17,0.68-0.27,1.04c-0.41,1.46-1.05,3.21-2.22,4.98c-1.15,1.77-2.77,3.57-4.91,5.04 c-2.15,1.45-4.83,2.52-7.78,2.87c-0.74,0.07-1.48,0.11-2.26,0.1c-0.75-0.05-1.49-0.05-2.27-0.21c-1.57-0.2-3.08-0.71-4.55-1.36 c-1.48-0.65-2.84-1.6-4.11-2.65c-1.26-1.08-2.34-2.38-3.28-3.79c-0.92-1.42-1.6-3-2.1-4.63c-0.48-1.64-0.68-3.36-0.71-5.07 c0.03-1.69,0.23-3.42,0.71-5.07c0.5-1.63,1.18-3.2,2.1-4.63c0.94-1.4,2.02-2.7,3.28-3.79c1.27-1.06,2.63-2,4.11-2.65 c2.93-1.35,6.16-1.79,9.07-1.47c2.99,0.35,5.64,1.42,7.8,2.87c2.14,1.47,3.77,3.28,4.91,5.04c1.17,1.77,1.82,3.52,2.22,4.98 c0.09,0.37,0.18,0.72,0.27,1.04c0.07,0.33,0.11,0.65,0.15,0.94c0.1,0.58,0.17,1.08,0.17,1.49c0.04,0.81,0.07,1.25,0.07,1.25 L475.34,784.41z M474.34,784.38c0,0-0.02-0.41-0.05-1.18c0-0.39-0.06-0.86-0.15-1.41c-0.04-0.28-0.08-0.57-0.14-0.89 c-0.08-0.31-0.16-0.64-0.25-0.99c-0.37-1.38-0.96-3.05-2.06-4.74c-1.07-1.69-2.6-3.42-4.63-4.84c-2.03-1.4-4.59-2.45-7.38-2.81 c-2.85-0.34-5.9,0.05-8.75,1.32c-1.43,0.61-2.75,1.51-3.99,2.52c-1.22,1.03-2.28,2.28-3.2,3.63c-0.9,1.37-1.58,2.89-2.08,4.46 c-0.48,1.59-0.69,3.24-0.74,4.92c0.05,1.67,0.26,3.33,0.74,4.92c0.51,1.58,1.18,3.1,2.08,4.46c0.92,1.35,1.98,2.59,3.2,3.63 c1.24,1.01,2.56,1.9,3.99,2.52c1.42,0.61,2.9,1.09,4.36,1.26c0.72,0.14,1.49,0.14,2.23,0.18c0.7,0,1.44-0.05,2.14-0.12 c2.82-0.36,5.36-1.41,7.4-2.81c2.03-1.42,3.55-3.15,4.63-4.84c1.09-1.69,1.69-3.36,2.06-4.74c0.09-0.35,0.17-0.68,0.25-0.99 c0.06-0.31,0.09-0.6,0.13-0.88c0.09-0.54,0.15-1.01,0.15-1.41c0.04-0.79,0.05-1.21,0.05-1.21L474.34,784.38z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3692_",
    className: "st4",
    d: "M458.35,795.24c-1.91-0.8-3.89-1.93-4.91-3.44c-2.41-3.12,3.89-3.62,4.68-6.39 c1.17-3.38-3.34-4.99-6.26-4.88c-1.16,0.03-2.29,0.18-3.39,0.45c-2.87,0.71-4.8,3.46-4.41,6.4c0.05,0.37,0.12,0.75,0.2,1.13 c1.6,7.35,8.75,12.03,15.99,10.46c5.48-1.19,9.43-5.64,10.32-10.92c-1.96,1.2-3.69,3.41-5.37,5.19 C463.4,795.35,460.86,796.43,458.35,795.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3691_",
    className: "st3",
    cx: 465.25,
    cy: 777.58,
    r: 1.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3690_",
    className: "st3",
    d: "M466.54,777.99c-0.42,1.98,0.94,5.41,1.3,7.4c0.05,0.26,0.08,0.52,0.01,0.77 c-0.05,0.17-0.14,0.33-0.24,0.49c-1.53,2.51-3.37,3.53-4.9,6.04c2.43-1.04,4.63-2.58,6.5-4.44c0.8-0.8,1.59-1.83,1.38-2.93 c-0.08-0.44-0.32-0.83-0.55-1.21c-1.17-1.95-2.28-3.92-3.34-5.93L466.54,777.99z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground01);
export default __webpack_public_path__ + "static/media/background-01.e3fe583458b3963c232aa82c8c46b9df.svg";
export { ForwardRef as ReactComponent };